/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme, alpha } from "@mui/material/styles";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 3 PRO React components

// Billing page components

import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDProgress from "components/MDProgress";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";

import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Icon from "@mui/material/Icon";
import { Icon as MuiIcon } from "@mui/material";
import MDButton from "components/MDButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import MDDropzone from "components/MDDropzone";
import swal from "sweetalert";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "components/MDInput";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useMaterialUIController } from "context";

import { useNavigate } from "react-router-dom";
import Link from "@mui/material/Link";
import { API_ESA_OFFICE, API_ESA_OFFICE_UPLOAD, API_CHAT } from "utils";
import { logoutUser } from "actions/AuthAction";
import { forceLogoutInactive } from "utils/forceLogoutInactive";
import ChatIcon from "@mui/icons-material/Chat";
import SvgIcon from "@mui/material/SvgIcon";
import SendIcon from "@mui/icons-material/Send";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import Avatar from "@mui/material/Avatar";

// Ikon WhatsApp (SVG)
const WhatsAppIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
    />
  </SvgIcon>
);

const PRIORITAS_COLOR = {
  Rendah: "#4caf50",
  Sedang: "#ffb300",
  Tinggi: "#f44336",
};

const INSTRUKSI_LIST_ACCENT = {
  blue: "#1565c0",
  green: "#2e7d32",
  red: "#c62828",
  slate: "#546e7a",
};

const INSTRUKSI_LIST_ACCENT_ARR = [
  INSTRUKSI_LIST_ACCENT.blue,
  INSTRUKSI_LIST_ACCENT.green,
  INSTRUKSI_LIST_ACCENT.red,
  INSTRUKSI_LIST_ACCENT.slate,
];

const instruksiListInfoAccentSx = (borderColor) => ({
  pl: 1.25,
  pr: 0.75,
  py: 0.45,
  borderLeft: "3px solid",
  borderLeftColor: borderColor,
  bgcolor: alpha(borderColor, 0.06),
  borderRadius: "0 6px 6px 0",
});

function stripHtmlTextInstruksi(html) {
  if (!html) return "";
  if (typeof document === "undefined") {
    return String(html)
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || "").trim();
}

// Format nomor HP untuk WhatsApp (62xxxxxxxxxx)
const formatNoHPForWhatsApp = (noHP) => {
  if (!noHP || typeof noHP !== "string") return null;
  let num = noHP.replace(/\D/g, "");
  if (num.startsWith("0")) num = "62" + num.slice(1);
  else if (!num.startsWith("62")) num = "62" + num;
  return num.length >= 10 ? num : null;
};

// Buat URL WhatsApp dengan pesan instruksi
const buildWhatsAppUrl = (noHP, instruksiItem) => {
  const num = formatNoHPForWhatsApp(noHP);
  if (!num) return null;
  const baseUrl = window.location.origin;
  const detailLink = `${baseUrl}/#/task-management/tugas/instruksi-detail/${instruksiItem?.instruksi_id || ""}`;
  const perihal = instruksiItem?.perihal || "Instruksi";
  let isiInstruksi =
    instruksiItem?.isi_instruksi?.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim() || "-";
  if (isiInstruksi.length > 800) {
    isiInstruksi = isiInstruksi.slice(0, 800) + "...";
  }
  const pemberiInstruksi = instruksiItem?.pengirim?.nama || "-";
  const deadline = instruksiItem?.tanggal_selesai
    ? formatDate(instruksiItem.tanggal_selesai)
    : "-";
  const message = [
    `*INSTRUKSI*`,
    ``,
    `*Perihal:* ${perihal}`,
    ``,
    `*Isi Instruksi:*`,
    isiInstruksi,
    ``,
    `*Pemberi Instruksi:* ${pemberiInstruksi}`,
    `*Deadline:* ${deadline}`,
    ``,
    `Silakan buka link berikut untuk detail lengkap:`,
    detailLink,
    `\n_Pesan ini dikirimkan dari Esa Office App_`,
  ]
    .filter(Boolean)
    .join("\n");
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
};

// Validasi tipe file
const isValidFileType = (file) => {
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel.sheet.macroEnabled.12",
    "image/jpeg",
    "image/jpg",
  ];
  const allowedExtensions = [
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".xlsm",
    ".jpg",
    ".jpeg",
  ];
  const fileExtension = file.name
    .toLowerCase()
    .substring(file.name.lastIndexOf("."));
  return (
    allowedTypes.includes(file.type) ||
    allowedExtensions.includes(fileExtension)
  );
};

// Validasi total ukuran semua file (3 MB = 3 * 1024 * 1024 bytes)
const isValidTotalSize = (files) => {
  const maxTotalSize = 3 * 1024 * 1024; // 3 MB total dalam bytes
  const totalSize = files.reduce((sum, file) => {
    const fileObj = file.file || file;
    return sum + (fileObj.size || 0);
  }, 0);
  return totalSize <= maxTotalSize;
};

// Helper untuk memilih icon dokumen
function getFileIcon(filename) {
  const ext = filename.split(".").pop().toLowerCase();
  if (ext === "pdf")
    return (
      <PictureAsPdfIcon sx={{ color: "#f44336", mr: 1 }} fontSize="small" />
    );
  if (["png", "jpg", "jpeg", "gif", "bmp", "svg", "webp"].includes(ext))
    return <ImageIcon sx={{ color: "#1976d2", mr: 1 }} fontSize="small" />;
  if (["doc", "docx"].includes(ext))
    return (
      <DescriptionIcon sx={{ color: "#1565c0", mr: 1 }} fontSize="small" />
    );
  if (["xls", "xlsx"].includes(ext))
    return (
      <DescriptionIcon sx={{ color: "#388e3c", mr: 1 }} fontSize="small" />
    );
  if (["ppt", "pptx"].includes(ext))
    return (
      <DescriptionIcon sx={{ color: "#ff9800", mr: 1 }} fontSize="small" />
    );
  return (
    <InsertDriveFileIcon sx={{ color: "#757575", mr: 1 }} fontSize="small" />
  );
}

// Helper format tanggal
function formatDate(dateStr) {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (isNaN(date)) return "-";
  return date.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

// Helper untuk format datetime
function formatDateTime(dateStr) {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (isNaN(date)) return "-";
  return date.toLocaleString("id-ID", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Data chart instruksi dibuat & diselesaikan
const chartInstruksi = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Agu",
    "Sep",
    "Okt",
    "Nov",
    "Des",
  ],
  datasets: [
    {
      chartType: "thin-bar",
      label: "Instruksi Dibuat",
      color: "info",
      data: [2, 3, 4, 5, 2, 1, 3, 4, 2, 3, 2, 1],
    },
    {
      chartType: "gradient-line",
      label: "Instruksi Selesai",
      color: "success",
      data: [1, 2, 2, 3, 1, 2, 2, 3, 1, 2, 1, 2],
    },
  ],
};

function DaftarTugas() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [instruksiOleh, setInstruksiOleh] = useState([]);
  const [openDetail, setOpenDetail] = useState({});
  const [instruksiTerima, setInstruksiTerima] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState(""); // 'lanjutkan' | 'selesaikan'
  const [selectedInstruksi, setSelectedInstruksi] = useState(null);
  const [modalValues, setModalValues] = useState({
    catatan: "",
    files: [],
    penerima: [],
    tingkat_perintah: "",
    status_pelaksana: "",
    waktu_diterima: "",
    waktu_selesai: "",
  });
  const [loadingModal, setLoadingModal] = useState(false);
  const [userId, setUserId] = useState(null);
  const [penerimaOptions, setPenerimaOptions] = useState([]);
  const [penerima, setPenerima] = useState({ penerima: [] });
  const dropzoneRef = useRef(null);

  const [tingkatPerintah, setTingkatPerintah] = useState("");
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [openDeleteInstruksiDialog, setOpenDeleteInstruksiDialog] =
    useState(false);
  const [deleteInstruksiTarget, setDeleteInstruksiTarget] = useState(null);
  const [activeFilter, setActiveFilter] = useState("total"); // total | selesai | dalamproses | belumdimulai | lewatdeadline
  const [searchInput, setSearchInput] = useState("");
  const [openFileDialog, setOpenFileDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [openPenerimaDialog, setOpenPenerimaDialog] = useState(false);
  const [selectedPenerima, setSelectedPenerima] = useState(null);
  const [selectedInstruksiForDialog, setSelectedInstruksiForDialog] =
    useState(null);
  const [statusUser, setStatusUser] = useState(null);
  const [penerimaFilterType, setPenerimaFilterType] = useState(null); // 'langsung' | 'lanjutan' | null (semua)
  const [openIsiInstruksiDialog, setOpenIsiInstruksiDialog] = useState(false);
  const [selectedIsiInstruksi, setSelectedIsiInstruksi] = useState(null);
  const [openPerihalDialog, setOpenPerihalDialog] = useState(false);
  const [selectedPerihal, setSelectedPerihal] = useState(null);
  const [tahun, setTahun] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editInstruksi, setEditInstruksi] = useState(null);
  const [editFormData, setEditFormData] = useState({
    perihal: "",
    tanggal: "",
    tanggal_selesai: "",
    isi_instruksi: "",
    prioritas: null,
    penerima: [],
    dokumen: [],
  });
  const [openDeleteConfirmDialog, setOpenDeleteConfirmDialog] = useState(false);
  const [deleteInstruksiId, setDeleteInstruksiId] = useState(null);
  const [openChatDialog, setOpenChatDialog] = useState(false);
  const [selectedChatInstruksi, setSelectedChatInstruksi] = useState(null);
  const [selectedChatPenerima, setSelectedChatPenerima] = useState(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loadingChat, setLoadingChat] = useState(false);
  const [refreshingChat, setRefreshingChat] = useState(false);
  const chatEndRef = useRef(null);

  // State untuk dialog respon pemberi instruksi
  const [openResponDialog, setOpenResponDialog] = useState(false);
  const [selectedPenerimaForRespon, setSelectedPenerimaForRespon] =
    useState(null);
  const [selectedRespon, setSelectedRespon] = useState("");
  const [openRatingDialog, setOpenRatingDialog] = useState(false);
  const [selectedRating, setSelectedRating] = useState(0);
  const [submittingRespon, setSubmittingRespon] = useState(false);

  // Ambil darkMode dari context
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const navigate = useNavigate();

  // Render teks dengan link yang dapat diklik (buka tab baru)
  const renderTextWithLinks = (text) => {
    if (!text || typeof text !== "string") return null;
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
    const parts = text.split(urlRegex);
    return parts.map((part, i) => {
      const isUrl = part.match(/^https?:\/\//i) || part.match(/^www\./i);
      const href = isUrl && part.match(/^www\./i) ? `https://${part}` : part;
      return isUrl ? (
        <Link
          key={i}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: "primary.main", textDecoration: "underline" }}
        >
          {part}
        </Link>
      ) : (
        <span key={i}>{part}</span>
      );
    });
  };

  useEffect(() => {
    // Ambil dinas_id dari localStorage
    let dinas_id = null;
    let user_id = null;
    let status = null;
    try {
      const user = localStorage.getItem("user");
      if (user) {
        const parsed = JSON.parse(user);
        dinas_id = parsed.dinas_id;
        user_id = parsed.uid;
        status = parsed.status;
      } else {
        logoutUser(navigate);
      }
    } catch (e) {}
    if (!dinas_id) return;
    axios
      .get(
        status === "pimpinan"
          ? `${API_ESA_OFFICE}users/pimpinan/list`
          : `${API_ESA_OFFICE}users/dinas/${dinas_id}`
      )
      .then((res) => {
        const options = (res.data || [])
          .filter((data) => data.user_id !== user_id)
          .map((data) => ({
            label: data.nama ? data.nama.split(" ")[0] : "-",
            value: data.user_id,
            avatar: data.uid_RSS
              ? `https://smartdh.rotendaokab.go.id/uploads/${data.uid_RSS}.jpg`
              : undefined,
          }));
        setPenerimaOptions(options);
      })
      .catch((err) => {
        setPenerimaOptions([]);
      });
    // eslint-disable-next-line
  }, []);

  const allOptions = [
    { label: "Pilih Semua", value: "all", avatar: "" },
    ...penerimaOptions,
  ];

  const handleChange = (event, value) => {
    const isSelectAll = value.some((v) => v.value === "all");
    if (isSelectAll) {
      if ((penerima.penerima || []).length === penerimaOptions.length) {
        setPenerima({ penerima: [] });
        setModalValues((prev) => ({ ...prev, penerima: [] }));
      } else {
        setPenerima({ penerima: penerimaOptions });
        setModalValues((prev) => ({ ...prev, penerima: penerimaOptions }));
      }
    } else {
      setPenerima({ penerima: value });
      setModalValues((prev) => ({ ...prev, penerima: value }));
    }
  };

  useEffect(() => {
    // Ambil userId dari localStorage saat mount
    let uid = null;
    try {
      const user = localStorage.getItem("user");
      if (user) {
        const parsed = JSON.parse(user);
        uid = parsed.uid;
      }
    } catch (e) {}
    setUserId(uid);

    // Set tahun default ke tahun saat ini
    const now = new Date();
    setTahun(now.getFullYear());
  }, []);

  function ambilData() {
    if (!userId) return Promise.resolve();

    setLoading(true);
    // Fetch semua data (tanpa filter tahun) - filter tahun hanya untuk Total dan Selesai
    const url = `${API_ESA_OFFICE}instruksi/oleh/${userId}`;

    return axios
      .get(url)
      .then((response) => {
        // Sort berdasarkan tanggal (terbaru ke lama)
        const sortedData = [...(response.data || [])].sort((a, b) => {
          const dateA = a.tanggal ? new Date(a.tanggal) : new Date(0);
          const dateB = b.tanggal ? new Date(b.tanggal) : new Date(0);
          return dateB - dateA; // Descending: terbaru ke lama
        });
        setInstruksiOleh(sortedData);
        setLoading(false);
        return sortedData;
      })
      .catch((error) => {
        setInstruksiOleh([]);
        setLoading(false);
      });
  }

  useEffect(() => {
    if (!userId) return;
    ambilData();
  }, [userId]);

  // Total & Tabel: filter berdasarkan tahun terpilih
  const instruksiFilteredByYear = useMemo(() => {
    const yearToUse = tahun || new Date().getFullYear();
    return instruksiOleh.filter(
      (item) =>
        item.tanggal && new Date(item.tanggal).getFullYear() === yearToUse
    );
  }, [instruksiOleh, tahun]);

  // Selesai: filter berdasarkan tahun terpilih (hanya untuk status Selesai)
  const instruksiUntukSelesai = useMemo(() => {
    const yearToUse = tahun || new Date().getFullYear();
    return instruksiOleh.filter((item) => {
      if (!item.tanggal) return false;
      if (new Date(item.tanggal).getFullYear() !== yearToUse) return false;
      if (!Array.isArray(item.rincian_penerima)) return false;
      const penerimaLangsung = item.rincian_penerima.filter(
        (p) => p.asal_perintah_dari_id === userId
      );
      if (penerimaLangsung.length === 0) return false;
      const totalPenerima = penerimaLangsung.length;
      const selesaiCount = penerimaLangsung.filter(
        (p) => (p.status || "").toLowerCase() === "selesai"
      ).length;
      return selesaiCount === totalPenerima && totalPenerima > 0;
    });
  }, [instruksiOleh, tahun, userId]);

  // Selesai belum dirating: instruksi selesai (filter tahun) dimana ada penerima langsung yang belum diberi respon/nilai bintang oleh pengirim
  const instruksiSelesaiBelumRating = useMemo(() => {
    return instruksiUntukSelesai.filter((item) => {
      if (!Array.isArray(item.rincian_penerima)) return false;
      const penerimaLangsung = item.rincian_penerima.filter(
        (p) => p.asal_perintah_dari_id === userId
      );
      return penerimaLangsung.some(
        (p) =>
          (p.status || "").toLowerCase() === "selesai" &&
          (!p.respon_pemberi_instruksi ||
            (String(p.respon_pemberi_instruksi || "").trim() === "Terima" &&
              !p.nilai))
      );
    });
  }, [instruksiUntukSelesai, userId]);

  // Refresh data di dialog daftar penerima jika instruksiOleh berubah dan dialog masih terbuka
  useEffect(() => {
    if (
      openPenerimaDialog &&
      selectedInstruksiForDialog &&
      instruksiOleh.length > 0
    ) {
      const updatedInstruksi = instruksiOleh.find(
        (item) => item.instruksi_id === selectedInstruksiForDialog.instruksi_id
      );
      if (updatedInstruksi && updatedInstruksi.rincian_penerima) {
        // Update selectedPenerima dengan data terbaru
        setSelectedPenerima(updatedInstruksi.rincian_penerima);
      }
    }
  }, [instruksiOleh, openPenerimaDialog, selectedInstruksiForDialog]);

  // Handler modal input
  const handleModalInput = (field, value) => {
    setModalValues((prev) => ({ ...prev, [field]: value }));
  };

  // Inject file ke Dropzone saat modalValues.files berubah (hanya jika modal terbuka)
  useEffect(() => {
    if (
      dropzoneRef.current &&
      modalValues.files &&
      Array.isArray(modalValues.files) &&
      modalValues.files.length > 0 &&
      openModal
    ) {
      const dz = dropzoneRef.current.dropzone;
      if (dz && dz.files.length === 0) {
        modalValues.files.forEach((file) => {
          const fileObj = file.file || file;
          // Validasi file sebelum inject
          if (!isValidFileType(fileObj)) {
            console.warn(`File ${fileObj.name} tidak valid dan akan diabaikan`);
            return;
          }
          if (
            !dz.files.find(
              (f) => f.name === fileObj.name && f.size === fileObj.size
            )
          ) {
            dz.emit("addedfile", fileObj);
            dz.emit("complete", fileObj);
          }
        });
      }
    }
  }, [modalValues.files, openModal]);

  // Event handler untuk memvalidasi dan menolak file sebelum ditambahkan ke dropzone
  useEffect(() => {
    const dz = dropzoneRef.current?.dropzone;
    if (!dz) return;

    // Handler untuk memvalidasi file sebelum ditambahkan (menggunakan accept)
    const handleAccept = (file, done) => {
      // Validasi tipe file
      if (!isValidFileType(file)) {
        done("Format file tidak didukung");
        return;
      }

      // Hitung total ukuran file yang sudah ada di dropzone
      const existingFilesSize = dz.files.reduce((sum, f) => {
        return sum + (f.size || 0);
      }, 0);

      // Hitung total ukuran setelah menambahkan file baru
      const totalSize = existingFilesSize + file.size;
      const maxTotalSize = 3 * 1024 * 1024; // 3 MB
      const totalSizeMB = totalSize / (1024 * 1024);

      // Jika total ukuran melebihi batas, tolak file
      if (totalSize > maxTotalSize) {
        done(`Total ukuran melebihi 3 MB (${totalSizeMB.toFixed(2)} MB)`);

        // Tampilkan pesan error
        swal({
          title: "Ukuran File Melebihi Batas",
          text: `Total ukuran semua file (${totalSizeMB.toFixed(
            2
          )} MB) melebihi batas maksimal 3 MB.\n\nSilakan hapus beberapa file yang sudah ada atau pilih file yang lebih kecil.`,
          icon: "error",
          button: "OK",
        });
        return;
      }

      // File diterima
      done(null);
    };

    // Handler untuk memvalidasi multiple files (menggunakan addedfiles sebagai fallback)
    const handleAddedFiles = (files) => {
      // Gunakan setTimeout untuk memastikan file sudah ditambahkan ke dz.files
      setTimeout(() => {
        // Hitung total ukuran file yang sekarang ada di dropzone
        const allFiles = dz.files;
        const totalSize = allFiles.reduce((sum, file) => {
          return sum + (file.size || 0);
        }, 0);
        const maxTotalSize = 3 * 1024 * 1024; // 3 MB
        const totalSizeMB = totalSize / (1024 * 1024);

        // Jika total ukuran melebihi batas, hapus file yang baru ditambahkan
        if (totalSize > maxTotalSize) {
          // Hapus file yang baru ditambahkan (file yang ada di parameter files)
          files.forEach((file) => {
            // Validasi tipe file terlebih dahulu
            if (!isValidFileType(file)) {
              // File dengan tipe tidak valid sudah ditolak oleh dropzone sendiri
              return;
            }
            // Hapus file yang menyebabkan total melebihi batas
            if (dz.files.includes(file)) {
              dz.emit("error", file, `Total ukuran melebihi 3 MB`);
              dz.removeFile(file);
            }
          });

          // Tampilkan pesan error
          swal({
            title: "Ukuran File Melebihi Batas",
            text: `Total ukuran semua file (${totalSizeMB.toFixed(
              2
            )} MB) melebihi batas maksimal 3 MB.\n\nSilakan hapus beberapa file yang sudah ada atau pilih file yang lebih kecil.`,
            icon: "error",
            button: "OK",
          });
        }
      }, 0);
    };

    // Tambahkan event listener untuk accept (validasi sebelum file ditambahkan)
    dz.on("accept", handleAccept);

    // Tambahkan event listener untuk addedfiles sebagai fallback
    dz.on("addedfiles", handleAddedFiles);

    // Cleanup: hapus event listener saat unmount
    return () => {
      if (dz) {
        dz.off("accept", handleAccept);
        dz.off("addedfiles", handleAddedFiles);
      }
    };
  }, [openModal]);

  // Handler Dropzone
  const handleDropzoneChange = (files) => {
    // Filter file yang valid berdasarkan tipe (sebagai double check)
    const validFiles = [];
    const invalidFiles = [];

    files.forEach((file) => {
      const fileObj = file.file || file;
      if (!isValidFileType(fileObj)) {
        invalidFiles.push({
          name: fileObj.name,
          reason: "Format file tidak didukung",
        });
      } else {
        validFiles.push(file);
      }
    });

    // Tampilkan pesan error jika ada file yang tidak valid (seharusnya tidak terjadi)
    if (invalidFiles.length > 0) {
      const errorMessages = invalidFiles
        .map((f) => `• ${f.name}: ${f.reason}`)
        .join("\n");
      swal({
        title: "File Tidak Valid",
        text: `File berikut tidak dapat diupload:\n\n${errorMessages}\n\nFormat yang didukung: PDF, Word (DOC/DOCX), Excel (XLS/XLSX), JPG`,
        icon: "error",
        button: "OK",
      });
    }

    // Update dengan file yang valid (file yang melebihi total ukuran sudah ditolak di event handler)
    if (invalidFiles.length === 0) {
      handleModalInput("files", validFiles);
    }
  };

  // Handler submit modal (lanjutkan/selesaikan)
  const handleSubmitModal = async () => {
    if (!selectedInstruksi) return;
    setLoadingModal(true);

    // Validasi total ukuran file sebelum submit
    if (modalValues.files && modalValues.files.length > 0) {
      const totalSize = modalValues.files.reduce((sum, file) => {
        const fileObj = file.file || file;
        return sum + (fileObj.size || 0);
      }, 0);
      const totalSizeMB = totalSize / (1024 * 1024);
      const maxSizeMB = 3;

      if (totalSizeMB > maxSizeMB) {
        swal({
          title: "Ukuran File Melebihi Batas",
          text: `Total ukuran semua file (${totalSizeMB.toFixed(
            2
          )} MB) melebihi batas maksimal ${maxSizeMB} MB.\n\nSilakan hapus beberapa file atau pilih file yang lebih kecil.`,
          icon: "error",
          button: "OK",
        });
        setLoadingModal(false);
        return;
      }
    }

    const missingFields = [];
    if (!modalValues.catatan) missingFields.push("Catatan");
    if (!modalValues.status_pelaksana) missingFields.push("Status Pelaksana");

    if (!modalValues.waktu_selesai) missingFields.push("Waktu Selesai");
    if (
      modalType === "lanjutkan" &&
      (!penerima.penerima || penerima.penerima.length === 0)
    )
      missingFields.push("Penerima");
    if (modalType === "lanjutkan" && !modalValues.waktu_diterima)
      missingFields.push("Waktu Diterima");

    if (missingFields.length > 0) {
      swal(
        "Gagal",
        `Harap isi semua nilai: ${missingFields.join(", ")}`,
        "error"
      );
      setLoadingModal(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("instruksi_tindak_lanjut", modalValues.catatan);
      formData.append("status_pelaksana", modalValues.status_pelaksana);

      formData.append("waktu_selesai", modalValues.waktu_selesai);
      formData.append("catatan_selesai", modalValues.catatan);
      if (modalValues.files && modalValues.files.length > 0) {
        modalValues.files.forEach((f) =>
          formData.append("file_tindak_lanjut", f.file || f)
        );
      }
      let url = "";
      let method = "post";
      if (modalType === "lanjutkan") {
        // Lanjutkan instruksi (POST)
        formData.append("tingkat_perintah", modalValues.tingkat_perintah);
        formData.append("asal_perintah_dari_id", userId);
        const penerimaList = penerima.penerima.map((p) => ({
          penerima_id: p.value,
          tingkat_perintah: selectedInstruksi.tingkat + 1,
          status_pelaksana: modalValues.status_pelaksana,
          waktu_diterima: modalValues.waktu_diterima,
          waktu_selesai: modalValues.waktu_selesai,
          instruksi_tindak_lanjut: modalValues.catatan,
        }));
        formData.append("penerima", JSON.stringify(penerimaList));
        url = `${API_ESA_OFFICE}instruksi/${selectedInstruksi.instruksi_id}/lanjutkan`;
        method = "post";
      } else {
        // Selesaikan instruksi (PUT) - gunakan instruksi_penerima_id, BUKAN instruksi_id
        const penerimaForUser = selectedInstruksi.rincian_penerima?.find(
          (p) => (p.user_id || p.penerima_id) === userId
        );
        const instruksiPenerimaId = penerimaForUser?.id;
        if (!instruksiPenerimaId) {
          swal("Gagal", "Data instruksi tidak valid.", "error");
          setLoadingModal(false);
          return;
        }
        url = `${API_ESA_OFFICE}instruksi/selesaikan/${instruksiPenerimaId}/${userId}`;
        method = "put";
      }
      await axios({
        method,
        url,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      swal(
        "Sukses",
        `Instruksi berhasil di${
          modalType === "lanjutkan" ? "lanjutkan" : "selesaikan"
        }!`,
        "success"
      );
      ambilData();
      handleCloseModal();
    } catch (err) {
      swal(
        "Gagal",
        err?.response?.data?.error || "Gagal mengirim data!",
        "error"
      );
    }
    setLoadingModal(false);
  };

  // Tambahkan fungsi untuk reset modal dan penerima
  const handleCloseModal = () => {
    setOpenModal(false);
    setPenerima({ penerima: [] });
    setTingkatPerintah("");
    setModalValues({
      catatan: "",
      files: [],
      penerima: [],
      tingkat_perintah: "",
      status_pelaksana: "",
      waktu_diterima: "",
      waktu_selesai: "",
    });
  };

  const handleDeleteChild = async () => {
    if (!deleteTarget) return;
    try {
      await axios.delete(
        `${API_ESA_OFFICE}instruksi/hapus/${deleteTarget.instruksi_id}/${deleteTarget.asal_perintah_dari_id}/${deleteTarget.penerima_id}/`
      );
      swal("Sukses", "Instruksi-penerima berhasil dihapus.", "success");
      setOpenDeleteDialog(false);
      setDeleteTarget(null);
      ambilData();
    } catch (err) {
      swal(
        "Gagal",
        err?.response?.data?.error || "Gagal menghapus data!",
        "error"
      );
      setOpenDeleteDialog(false);
      setDeleteTarget(null);
    }
  };

  const handleDeleteInstruksi = async () => {
    if (!deleteInstruksiTarget) return;
    try {
      await axios.delete(
        `${API_ESA_OFFICE}instruksi/hapus-utama/${deleteInstruksiTarget.instruksi_id}`
      );
      swal("Sukses", "Instruksi berhasil dihapus.", "success");
      setOpenDeleteInstruksiDialog(false);
      setDeleteInstruksiTarget(null);
      ambilData();
    } catch (err) {
      swal(
        "Gagal",
        err?.response?.data?.error || "Gagal menghapus data!",
        "error"
      );
      setOpenDeleteInstruksiDialog(false);
      setDeleteInstruksiTarget(null);
    }
  };

  // Fungsi helper untuk cek apakah instruksi sudah selesai
  const isInstruksiSelesai = (item, pengirimId) => {
    if (!item.rincian_penerima || !Array.isArray(item.rincian_penerima)) {
      return false;
    }

    const penerimaLangsung = item.rincian_penerima.filter(
      (p) => p.asal_perintah_dari_id === pengirimId
    );

    if (penerimaLangsung.length === 0) {
      return false;
    }

    const selesaiCount = penerimaLangsung.filter(
      (p) => (p.status || "").toLowerCase() === "selesai"
    ).length;

    return (
      selesaiCount === penerimaLangsung.length && penerimaLangsung.length > 0
    );
  };

  // Handler untuk membuka dialog edit
  const handleOpenEditDialog = (item) => {
    setEditInstruksi(item);

    // Parse dokumen jika berupa JSON string
    let dokumenArr = [];
    if (item.dokumen) {
      if (Array.isArray(item.dokumen)) {
        dokumenArr = item.dokumen;
      } else if (
        typeof item.dokumen === "string" &&
        item.dokumen.trim().startsWith("[")
      ) {
        try {
          dokumenArr = JSON.parse(item.dokumen);
        } catch (e) {
          dokumenArr = [];
        }
      }
    }

    // Ambil penerima langsung saja
    const penerimaLangsung = Array.isArray(item.rincian_penerima)
      ? item.rincian_penerima.filter((p) => p.asal_perintah_dari_id === userId)
      : [];

    setEditFormData({
      perihal: item.perihal || "",
      tanggal: item.tanggal
        ? new Date(item.tanggal).toISOString().slice(0, 16)
        : "",
      tanggal_selesai: item.tanggal_selesai
        ? new Date(item.tanggal_selesai).toISOString().slice(0, 16)
        : "",
      isi_instruksi: item.isi_instruksi || "",
      prioritas: item.prioritas || null,
      penerima: penerimaLangsung.map((p) => ({
        penerima_id: p.user_id || p.penerima_id,
        asal_perintah_dari_id: userId,
        tingkat_perintah: p.tingkat || "1",
      })),
      dokumen: dokumenArr,
    });
    setOpenEditDialog(true);
  };

  // Handler untuk menutup dialog edit
  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setEditInstruksi(null);
    setEditFormData({
      perihal: "",
      tanggal: "",
      tanggal_selesai: "",
      isi_instruksi: "",
      prioritas: null,
      penerima: [],
      dokumen: [],
    });
  };

  // Handler untuk submit edit
  const handleSubmitEdit = async () => {
    if (!editInstruksi) return;

    try {
      setLoadingModal(true);
      const formData = new FormData();
      formData.append("pengirim_id", userId);
      formData.append("tanggal", editFormData.tanggal);
      formData.append("tanggal_selesai", editFormData.tanggal_selesai || "");
      formData.append("isi_instruksi", editFormData.isi_instruksi);
      formData.append("prioritas", editFormData.prioritas || "");
      formData.append("status", "Terkirim");
      formData.append("perihal", editFormData.perihal);
      formData.append("penerima", JSON.stringify(editFormData.penerima));

      // Tambahkan dokumen lama jika ada
      if (editFormData.dokumen && editFormData.dokumen.length > 0) {
        const dokumenLama = editFormData.dokumen.filter(
          (d) => typeof d === "string"
        );
        if (dokumenLama.length > 0) {
          formData.append("dokumen", JSON.stringify(dokumenLama));
        }
      }

      // Tambahkan file baru jika ada
      if (editFormData.dokumen && editFormData.dokumen.length > 0) {
        editFormData.dokumen.forEach((file) => {
          if (file instanceof File) {
            formData.append("dokumen", file);
          }
        });
      }

      await axios.put(
        `${API_ESA_OFFICE}instruksi/edit/${editInstruksi.instruksi_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      swal("Berhasil", "Instruksi berhasil diupdate", "success");
      handleCloseEditDialog();
      ambilData();
    } catch (error) {
      swal(
        "Gagal",
        error?.response?.data?.error || "Gagal mengupdate instruksi",
        "error"
      );
    } finally {
      setLoadingModal(false);
    }
  };

  // Handler untuk membuka dialog konfirmasi delete
  const handleOpenDeleteConfirm = (item) => {
    setDeleteInstruksiId(item.instruksi_id);
    setOpenDeleteConfirmDialog(true);
  };

  // Handler untuk menutup dialog konfirmasi delete
  const handleCloseDeleteConfirm = () => {
    setOpenDeleteConfirmDialog(false);
    setDeleteInstruksiId(null);
  };

  // Handler untuk konfirmasi delete
  const handleConfirmDelete = async () => {
    if (!deleteInstruksiId) return;

    try {
      setLoadingModal(true);
      await axios.delete(
        `${API_ESA_OFFICE}instruksi/hapus-utama/${deleteInstruksiId}`
      );
      swal("Berhasil", "Instruksi berhasil dihapus", "success");
      handleCloseDeleteConfirm();
      ambilData();
    } catch (error) {
      swal(
        "Gagal",
        error?.response?.data?.error || "Gagal menghapus instruksi",
        "error"
      );
    } finally {
      setLoadingModal(false);
    }
  };

  // Handler untuk membuka file
  const handleOpenFile = (file) => {
    const filename = file.split("/").pop();
    const ext = filename.split(".").pop().toLowerCase();

    if (ext === "pdf") {
      // Buka PDF langsung di tab baru
      window.open(`${API_ESA_OFFICE_UPLOAD}${file}`, "_blank");
    } else {
      // Tampilkan dialog download untuk file non-PDF
      setSelectedFile({
        name: filename,
        url: `${API_ESA_OFFICE_UPLOAD}${file}`,
        type: ext,
      });
      setOpenFileDialog(true);
    }
  };

  // Handler untuk download file
  const handleDownloadFile = () => {
    if (selectedFile) {
      const link = document.createElement("a");
      link.href = selectedFile.url;
      link.download = selectedFile.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setOpenFileDialog(false);
      setSelectedFile(null);
    }
  };

  // Helper functions untuk render kolom tabel
  // Hanya menghitung penerima langsung (asal_perintah_dari_id === userId)
  const renderProgress = (rincianPenerima, pengirimId) => {
    if (!Array.isArray(rincianPenerima) || rincianPenerima.length === 0) {
      return (
        <MDTypography variant="caption" color="text.secondary">
          Belum ada penerima
        </MDTypography>
      );
    }
    // Filter hanya penerima langsung (asal_perintah_dari_id === pengirimId)
    const penerimaLangsung = rincianPenerima.filter(
      (p) => p.asal_perintah_dari_id === pengirimId
    );

    if (penerimaLangsung.length === 0) {
      return (
        <MDTypography variant="caption" color="text.secondary">
          Tidak ada penerima langsung
        </MDTypography>
      );
    }

    const totalPenerima = penerimaLangsung.length;
    const selesaiCount = penerimaLangsung.filter(
      (p) => (p.status || "").toLowerCase() === "selesai"
    ).length;
    const progress =
      totalPenerima > 0 ? Math.round((selesaiCount / totalPenerima) * 100) : 0;

    return (
      <MDBox>
        <MDProgress value={progress} color="info" variant="gradient" />
        <MDTypography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 0.5, display: "block" }}
        >
          {selesaiCount}/{totalPenerima} ({progress}%)
        </MDTypography>
      </MDBox>
    );
  };

  const handleOpenPenerimaDialog = (
    penerima,
    instruksiData,
    filterType = null
  ) => {
    setSelectedPenerima(penerima);
    setSelectedInstruksiForDialog(instruksiData);
    setPenerimaFilterType(filterType); // 'langsung' | 'lanjutan' | null (semua)
    setOpenPenerimaDialog(true);
  };

  const handleClosePenerimaDialog = () => {
    setOpenPenerimaDialog(false);
    setSelectedPenerima(null);
    setSelectedInstruksiForDialog(null);
    setPenerimaFilterType(null);
  };

  // Handler untuk dialog isi instruksi
  const handleOpenIsiInstruksiDialog = (isiInstruksi) => {
    setSelectedIsiInstruksi(isiInstruksi);
    setOpenIsiInstruksiDialog(true);
  };

  const handleCloseIsiInstruksiDialog = () => {
    setOpenIsiInstruksiDialog(false);
    setSelectedIsiInstruksi(null);
  };

  // Handler untuk dialog perihal
  const handleOpenPerihalDialog = (perihal) => {
    setSelectedPerihal(perihal);
    setOpenPerihalDialog(true);
  };

  const handleClosePerihalDialog = () => {
    setOpenPerihalDialog(false);
    setSelectedPerihal(null);
  };

  // Handler untuk dialog respon pemberi instruksi
  const handleOpenResponDialog = (penerima) => {
    setSelectedPenerimaForRespon(penerima);
    setSelectedRespon(penerima.respon_pemberi_instruksi || "");
    // Set rating jika sudah ada dan respon adalah Terima
    if (penerima.respon_pemberi_instruksi === "Terima" && penerima.nilai) {
      setSelectedRating(penerima.nilai);
    } else {
      setSelectedRating(0);
    }
    setOpenResponDialog(true);
  };

  const handleCloseResponDialog = () => {
    setOpenResponDialog(false);
    setSelectedPenerimaForRespon(null);
    setSelectedRespon("");
    setSelectedRating(0);
  };

  // Handler untuk memilih respon
  const handleSelectRespon = (respon) => {
    setSelectedRespon(respon);
    if (respon === "Terima") {
      // Jika sedang edit dan sudah ada rating, pertahankan rating
      // Jika belum ada rating, reset ke 0
      if (
        !selectedPenerimaForRespon?.respon_pemberi_instruksi ||
        selectedPenerimaForRespon?.respon_pemberi_instruksi !== "Terima" ||
        !selectedPenerimaForRespon?.nilai
      ) {
        setSelectedRating(0);
      }
      // Tutup dialog respon dan buka dialog rating
      setOpenResponDialog(false);
      setOpenRatingDialog(true);
    } else {
      // Jika memilih Perbaiki atau Tolak, reset rating
      setSelectedRating(0);
    }
  };

  // Handler untuk submit respon
  const handleSubmitRespon = async () => {
    if (!selectedPenerimaForRespon || !selectedPenerimaForRespon.id) {
      swal({
        title: "Error",
        text: "Data penerima tidak valid",
        icon: "error",
        button: "OK",
      });
      return;
    }

    if (!selectedRespon) {
      swal({
        title: "Perhatian",
        text: "Silakan pilih respon terlebih dahulu",
        icon: "warning",
        button: "OK",
      });
      return;
    }

    // Jika Terima, harus ada rating
    if (selectedRespon === "Terima" && selectedRating === 0) {
      swal({
        title: "Perhatian",
        text: "Silakan pilih penilaian terlebih dahulu",
        icon: "warning",
        button: "OK",
      });
      return;
    }

    setSubmittingRespon(true);
    try {
      const payload = {
        respon_pemberi_instruksi: selectedRespon,
        nilai: selectedRespon === "Terima" ? selectedRating : null,
      };

      await axios.put(
        `${API_ESA_OFFICE}instruksi/respon/${selectedPenerimaForRespon.id}`,
        payload
      );

      swal({
        title: "Berhasil!",
        text:
          selectedRespon === "Terima"
            ? "Respon 'Terima' dan penilaian berhasil disimpan"
            : `Respon '${selectedRespon}' berhasil disimpan. Status diubah menjadi Proses.`,
        icon: "success",
        button: "OK",
      });

      // Simpan instruksi_id untuk refresh dialog
      const instruksiIdForRefresh = selectedInstruksiForDialog?.instruksi_id;
      const isDialogOpen = openPenerimaDialog;

      // Refresh data utama dan update dialog
      ambilData()
        .then((updatedData) => {
          // Update data di dialog jika dialog masih terbuka
          if (isDialogOpen && instruksiIdForRefresh && updatedData) {
            // Cari instruksi terbaru dari data yang baru di-refresh
            const updatedInstruksi = updatedData.find(
              (item) => item.instruksi_id === instruksiIdForRefresh
            );
            if (updatedInstruksi && updatedInstruksi.rincian_penerima) {
              setSelectedPenerima(updatedInstruksi.rincian_penerima);
            }
          }
        })
        .catch((error) => {
          console.error("Error refreshing data:", error);
        });

      handleCloseResponDialog();
      setOpenRatingDialog(false);
      setSelectedRating(0);
      setSelectedRespon("");
    } catch (error) {
      console.error("Error submitting respon:", error);
      swal({
        title: "Error",
        text:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Gagal mengirimkan respon",
        icon: "error",
        button: "OK",
      });
    } finally {
      setSubmittingRespon(false);
    }
  };

  // Handler untuk rating click
  const handleRatingClick = (rating) => {
    setSelectedRating(rating);
  };

  // Handler untuk submit rating (dari dialog rating)
  const handleSubmitRating = async () => {
    if (selectedRating === 0) {
      swal({
        title: "Perhatian",
        text: "Silakan pilih penilaian terlebih dahulu",
        icon: "warning",
        button: "OK",
      });
      return;
    }

    if (!selectedPenerimaForRespon || !selectedPenerimaForRespon.id) {
      swal({
        title: "Error",
        text: "Data penerima tidak valid",
        icon: "error",
        button: "OK",
      });
      return;
    }

    setSubmittingRespon(true);
    try {
      const payload = {
        respon_pemberi_instruksi: "Terima",
        nilai: selectedRating,
      };

      await axios.put(
        `${API_ESA_OFFICE}instruksi/respon/${selectedPenerimaForRespon.id}`,
        payload
      );

      swal({
        title: "Berhasil!",
        text: "Respon 'Terima' dan penilaian berhasil disimpan",
        icon: "success",
        button: "OK",
      });

      // Simpan instruksi_id untuk refresh dialog
      const instruksiIdForRefresh = selectedInstruksiForDialog?.instruksi_id;
      const isDialogOpen = openPenerimaDialog;

      // Refresh data utama dan update dialog
      ambilData()
        .then((updatedData) => {
          // Update data di dialog jika dialog masih terbuka
          if (isDialogOpen && instruksiIdForRefresh && updatedData) {
            // Cari instruksi terbaru dari data yang baru di-refresh
            const updatedInstruksi = updatedData.find(
              (item) => item.instruksi_id === instruksiIdForRefresh
            );
            if (updatedInstruksi && updatedInstruksi.rincian_penerima) {
              setSelectedPenerima(updatedInstruksi.rincian_penerima);
            }
          }
        })
        .catch((error) => {
          console.error("Error refreshing data:", error);
        });

      setOpenRatingDialog(false);
      setSelectedRating(0);
      setSelectedRespon("");
      setSelectedPenerimaForRespon(null);
    } catch (error) {
      console.error("Error submitting respon:", error);
      swal({
        title: "Error",
        text:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Gagal mengirimkan respon",
        icon: "error",
        button: "OK",
      });
    } finally {
      setSubmittingRespon(false);
    }
  };

  // Handler untuk cancel rating dialog
  const handleCancelRating = async () => {
    const cancelResult = await swal({
      title: "Konfirmasi",
      text: "Apakah Anda yakin ingin membatalkan? Penilaian wajib diisi untuk respon 'Terima'.",
      icon: "warning",
      buttons: ["Tidak", "Ya, Batalkan"],
      dangerMode: true,
    });

    if (cancelResult) {
      setOpenRatingDialog(false);
      setSelectedRating(0);
      setSelectedRespon("");
      setSelectedPenerimaForRespon(null);
    }
  };

  // Helper function untuk mendapatkan fresh token
  const getFreshToken = async (user) => {
    if (!user?.uid_RSS) {
      throw new Error("User uid_RSS tidak ditemukan");
    }

    try {
      const tokenResponse = await axios.get(
        `${API_ESA_OFFICE}users/uid/${user.uid_RSS}`,
        {
          withCredentials: true, // Kirim cookie untuk refresh token
        }
      );

      if (tokenResponse.data?.accessToken) {
        const token = tokenResponse.data.accessToken;
        // Simpan token ke localStorage
        const updatedUser = { ...user, accessToken: token };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        return token;
      }
      throw new Error("Access token tidak ditemukan di response");
    } catch (error) {
      console.error("Error getting fresh token:", error);
      
      // Handle error khusus untuk status_EO tidak aktif - logout tanpa dialog
      if (
        error.response &&
        error.response.status === 403 &&
        error.response.data?.status_EO != null
      ) {
        forceLogoutInactive();
        return;
      }
      
      throw error;
    }
  };

  // Fungsi untuk fetch chat history
  const fetchChatHistory = async (instruksiItem, token) => {
    const instruksiId = instruksiItem.instruksi_id;

    // Fetch chat history
    let response;
    try {
      response = await axios.get(`${API_CHAT}instruksi/${instruksiId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
    } catch (error) {
      // Jika 403, coba refresh token sekali lagi
      if (error.response?.status === 403) {
        console.log("🔄 Token mungkin expired, refreshing...");
        try {
          const user = JSON.parse(localStorage.getItem("user")) || {};
          token = await getFreshToken(user);
          response = await axios.get(`${API_CHAT}instruksi/${instruksiId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          });
        } catch (retryError) {
          console.error(
            "❌ Chat API Error after retry:",
            retryError.response?.data || retryError.message
          );
          throw retryError;
        }
      } else {
        throw error;
      }
    }

    // Set chat messages
    if (response && response.data && response.data.success) {
      const messages = response.data.data || [];
      setChatMessages(messages);

      // Auto mark all messages as read
      try {
        const user = JSON.parse(localStorage.getItem("user")) || {};
        const currentUserId =
          userId || user.uid_RSS || user.user_id || user.uid;
        const markReadResponse = await axios.put(
          `${API_CHAT}instruksi/${instruksiId}/read-all`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          }
        );
        if (markReadResponse.data.success) {
          console.log("✅ All messages marked as read");
          setChatMessages((prev) =>
            prev.map((msg) => {
              if (!msg.waktu_baca && msg.penerima_id === currentUserId) {
                return { ...msg, waktu_baca: new Date().toISOString() };
              }
              return msg;
            })
          );
        }
      } catch (markReadError) {
        console.warn("⚠️ Failed to mark messages as read:", markReadError);
      }
    }

    return response;
  };

  // Handler untuk refresh chat messages
  const handleRefreshChat = async () => {
    if (!selectedChatInstruksi || refreshingChat) {
      return;
    }

    setRefreshingChat(true);
    try {
      const user = JSON.parse(localStorage.getItem("user")) || {};
      if (!user.uid_RSS) {
        swal("Error", "Data user tidak lengkap. Silakan login ulang.", "error");
        setRefreshingChat(false);
        return;
      }

      const token = await getFreshToken(user);
      await fetchChatHistory(selectedChatInstruksi, token);

      // Scroll to bottom after refresh
      setTimeout(() => {
        if (chatEndRef.current) {
          chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 150);
    } catch (error) {
      console.error("Error refreshing chat:", error);
      swal("Error", "Gagal refresh chat. Silakan coba lagi.", "error");
    } finally {
      setRefreshingChat(false);
    }
  };

  // Handler untuk membuka chat
  const handleOpenChat = async (instruksiItem, penerima) => {
    setSelectedChatInstruksi(instruksiItem);
    setSelectedChatPenerima(penerima);
    setOpenChatDialog(true);
    setLoadingChat(true);
    setChatMessages([]);
    setNewMessage(""); // Reset input message

    try {
      // Ambil user dari localStorage
      const user = JSON.parse(localStorage.getItem("user")) || {};

      if (!user.uid_RSS) {
        swal("Error", "Data user tidak lengkap. Silakan login ulang.", "error");
        setLoadingChat(false);
        return;
      }

      // Selalu dapatkan fresh token untuk memastikan tidak expired
      let token;
      try {
        token = await getFreshToken(user);
        console.log("✅ Fresh token obtained");
      } catch (tokenError) {
        console.error("Error getting fresh token:", tokenError);
        swal(
          "Error",
          "Gagal mendapatkan token akses. Silakan login ulang.",
          "error"
        );
        setLoadingChat(false);
        return;
      }

      if (!token) {
        swal("Error", "Token tidak ditemukan. Silakan login ulang.", "error");
        setLoadingChat(false);
        return;
      }

      // Fetch chat history
      try {
        await fetchChatHistory(instruksiItem, token);
        // Scroll to bottom
        setTimeout(() => {
          if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: "smooth" });
          }
        }, 150);
      } catch (error) {
        console.error("Error loading chat:", error);
        if (error.response?.status >= 400) {
          swal(
            "Error",
            error.response?.data?.error || "Gagal memuat chat",
            "error"
          );
        }
        setChatMessages([]);
      }
    } catch (error) {
      console.error("Error loading chat:", error);
      swal("Error", "Gagal memuat chat. Silakan coba lagi.", "error");
    } finally {
      setLoadingChat(false);
    }
  };

  // Handler untuk menutup chat
  const handleCloseChat = () => {
    setOpenChatDialog(false);
    setSelectedChatInstruksi(null);
    setSelectedChatPenerima(null);
    setChatMessages([]);
    setNewMessage("");
  };

  // Handler untuk mengirim pesan
  const handleSendMessage = async () => {
    if (!newMessage.trim() || !selectedChatInstruksi || !selectedChatPenerima) {
      return;
    }

    const messageText = newMessage.trim();
    setNewMessage(""); // Clear input immediately

    try {
      const user = JSON.parse(localStorage.getItem("user")) || {};

      if (!user.uid_RSS) {
        swal("Error", "Data user tidak lengkap. Silakan login ulang.", "error");
        setNewMessage(messageText); // Restore message on error
        return;
      }

      // Dapatkan fresh token
      let token;
      try {
        token = await getFreshToken(user);
      } catch (tokenError) {
        console.error("Error getting fresh token:", tokenError);
        swal(
          "Error",
          "Gagal mendapatkan token akses. Silakan login ulang.",
          "error"
        );
        setNewMessage(messageText); // Restore message on error
        return;
      }

      if (!token) {
        swal("Error", "Token tidak ditemukan. Silakan login ulang.", "error");
        setNewMessage(messageText); // Restore message on error
        return;
      }

      // Jangan kirim instruksi_penerima_id agar semua pesan masuk ke room yang sama
      // Room name akan menjadi instruksi_${instruksi_id} tanpa instruksi_penerima_id
      // Pastikan instruksi_id konsisten (number)
      const instruksiIdRaw = selectedChatInstruksi.instruksi_id;
      const instruksiId = parseInt(instruksiIdRaw);
      const roomName = `instruksi_${instruksiId}`;

      console.log("📤 Sending message from daftar-tugas:", {
        instruksi_id_raw: instruksiIdRaw,
        instruksi_id: instruksiId,
        room_name: roomName,
        penerima_id:
          selectedChatPenerima.user_id || selectedChatPenerima.penerima_id,
      });

      const messageData = {
        instruksi_id: instruksiId, // Pastikan sebagai number
        // Tidak kirim instruksi_penerima_id agar semua user di instruksi yang sama menerima pesan
        instruksi_penerima_id: null,
        penerima_id:
          selectedChatPenerima.user_id || selectedChatPenerima.penerima_id,
        pesan: messageText,
      };

      // Optimistic update - tambahkan pesan langsung ke state
      const currentUser = JSON.parse(localStorage.getItem("user")) || {};
      const currentUserId = userId || currentUser.uid || currentUser.user_id;
      const tempId = `temp-${Date.now()}-${Math.random()}`;
      const tempMessage = {
        id_chat: tempId,
        pesan: messageText,
        pengirim_id: currentUserId,
        pengirim_nama: currentUser.nama || user.nama || "Anda",
        pengirim_profil: currentUser.uid_RSS || user.uid_RSS,
        waktu_kirim: new Date().toISOString(),
        isSending: true, // Flag untuk menandai pesan sedang dikirim
      };

      // Tambahkan pesan langsung ke state (optimistic update)
      setChatMessages((prev) => {
        // Pastikan tidak ada duplikasi
        const exists = prev.some((msg) => msg.id_chat === tempId);
        if (exists) return prev;
        return [...prev, tempMessage];
      });

      // Scroll ke bawah setelah menambahkan pesan
      setTimeout(() => {
        if (chatEndRef.current) {
          chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 150);

      // Kirim via REST API
      let response;
      try {
        response = await axios.post(`${API_CHAT}instruksi`, messageData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        if (response.data && response.data.success) {
          // Hapus pesan temporary
          setChatMessages((prev) =>
            prev.filter((msg) => msg.id_chat !== tempId)
          );

          // Refresh chat untuk mendapatkan pesan terbaru
          await fetchChatHistory(selectedChatInstruksi, token);

          // Scroll to bottom
          setTimeout(() => {
            if (chatEndRef.current) {
              chatEndRef.current.scrollIntoView({ behavior: "smooth" });
            }
          }, 150);
        }
      } catch (error) {
        console.error("Error sending message:", error);
        // Hapus pesan temporary jika error
        setChatMessages((prev) => prev.filter((msg) => msg.id_chat !== tempId));
        setNewMessage(messageText); // Restore message
        swal(
          "Error",
          error.response?.data?.error || "Gagal mengirim pesan",
          "error"
        );
        return;
      }
    } catch (error) {
      console.error("Error sending message:", error);
      // Hapus pesan temporary jika error
      setChatMessages((prev) =>
        prev.filter((msg) => !msg.isSending || msg.pesan !== messageText)
      );
      setNewMessage(messageText); // Restore message
      swal(
        "Error",
        error.response?.data?.error || "Gagal mengirim pesan",
        "error"
      );
    }
  };

  // Handler untuk delete message
  const handleDeleteMessage = async (chatId) => {
    if (!chatId) return;

    const confirmed = await swal({
      title: "Hapus Pesan?",
      text: "Pesan yang dihapus tidak dapat dikembalikan.",
      icon: "warning",
      buttons: {
        cancel: {
          text: "Batal",
          value: false,
          visible: true,
        },
        confirm: {
          text: "Hapus",
          value: true,
          visible: true,
        },
      },
      dangerMode: true,
    });

    if (!confirmed) return;

    try {
      const user = JSON.parse(localStorage.getItem("user")) || {};
      const token = await getFreshToken(user);

      await axios.delete(`${API_CHAT}instruksi/${chatId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

      // Hapus pesan dari state
      setChatMessages((prev) => prev.filter((msg) => msg.id_chat !== chatId));
      swal("Berhasil", "Pesan berhasil dihapus", "success");
    } catch (error) {
      console.error("Error deleting message:", error);
      swal("Error", "Gagal menghapus pesan", "error");
    }
  };

  // Format waktu untuk chat
  const formatChatTime = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    // Format waktu: HH:mm
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const timeStr = `${hours}:${minutes}`;

    // Jika hari ini
    if (diffDays === 0) {
      return timeStr;
    }

    // Jika kemarin
    if (diffDays === 1) {
      return `Kemarin ${timeStr}`;
    }

    // Jika dalam seminggu
    if (diffDays < 7) {
      const dayNames = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
      ];
      return `${dayNames[date.getDay()]} ${timeStr}`;
    }

    // Jika lebih dari seminggu
    const day = date.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ];
    const month = monthNames[date.getMonth()];

    // Jika tahun berbeda, tambahkan tahun
    if (date.getFullYear() !== now.getFullYear()) {
      return `${day} ${month} ${date.getFullYear()} ${timeStr}`;
    }

    return `${day} ${month} ${timeStr}`;
  };

  // Auto scroll ke bawah saat ada pesan baru
  useEffect(() => {
    if (chatEndRef.current && chatMessages.length > 0) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatMessages]);

  const renderPenerima = (rincianPenerima, instruksiItem) => {
    if (!Array.isArray(rincianPenerima) || rincianPenerima.length === 0) {
      return (
        <MDTypography variant="caption" color="text.secondary">
          Tidak ada penerima
        </MDTypography>
      );
    }

    if (rincianPenerima.length === 1) {
      return (
        <MDBox
          display="flex"
          alignItems="center"
          onClick={() =>
            handleOpenPenerimaDialog(rincianPenerima, instruksiItem)
          }
          sx={{ cursor: "pointer" }}
        >
          <MDAvatar
            src={
              rincianPenerima[0].uid_RSS
                ? `https://smartdh.rotendaokab.go.id/uploads/${rincianPenerima[0].uid_RSS}.jpg`
                : undefined
            }
            alt={rincianPenerima[0].nama}
            size="sm"
            sx={{ mr: 1 }}
          />
          <MDTypography variant="button" fontWeight="medium">
            {rincianPenerima[0].nama}
          </MDTypography>
        </MDBox>
      );
    }

    return (
      <Button
        variant="contained"
        size="small"
        onClick={() => handleOpenPenerimaDialog(rincianPenerima, instruksiItem)}
      >
        {rincianPenerima.length} Penerima
      </Button>
    );
  };

  // Helper function untuk mengecek apakah instruksi approved
  const isInstruksiApproved = (rincianPenerima, pengirimId) => {
    if (!Array.isArray(rincianPenerima) || rincianPenerima.length === 0) {
      return false;
    }

    const penerimaLangsung = rincianPenerima.filter(
      (p) => p.asal_perintah_dari_id === pengirimId
    );

    if (penerimaLangsung.length === 0) {
      return false;
    }

    // Cek apakah semua penerima langsung memiliki status "selesai" (progress 100%)
    const semuaSelesai = penerimaLangsung.every(
      (p) => (p.status || "").toLowerCase() === "selesai"
    );

    if (!semuaSelesai) {
      return false;
    }

    // Cek apakah semua penerima langsung memiliki respon "Terima"
    const semuaTerima = penerimaLangsung.every(
      (p) => (p.respon_pemberi_instruksi || "").trim() === "Terima"
    );

    return semuaTerima;
  };

  // Render penerima langsung
  const renderPenerimaLangsung = (rincianPenerima, instruksiItem) => {
    if (!Array.isArray(rincianPenerima) || rincianPenerima.length === 0) {
      return (
        <MDTypography variant="caption" color="text.secondary">
          -
        </MDTypography>
      );
    }

    const penerimaLangsung = rincianPenerima.filter(
      (p) => p.asal_perintah_dari_id === userId
    );

    if (penerimaLangsung.length === 0) {
      return (
        <MDTypography variant="caption" color="text.secondary">
          -
        </MDTypography>
      );
    }

    if (penerimaLangsung.length === 1) {
      return (
        <MDBox display="flex" alignItems="center" gap={1}>
          <MDBox
            display="flex"
            alignItems="center"
            onClick={() =>
              handleOpenPenerimaDialog(
                rincianPenerima,
                instruksiItem,
                "langsung"
              )
            }
            sx={{ cursor: "pointer", flex: 1 }}
          >
            <MDAvatar
              src={
                penerimaLangsung[0].uid_RSS
                  ? `https://smartdh.rotendaokab.go.id/uploads/${penerimaLangsung[0].uid_RSS}.jpg`
                  : undefined
              }
              alt={penerimaLangsung[0].nama}
              size="sm"
              sx={{ mr: 1 }}
            />
            <MDTypography variant="button" fontWeight="medium">
              {penerimaLangsung[0].nama}
            </MDTypography>
          </MDBox>
          <IconButton
            size="small"
            color="primary"
            onClick={(e) => {
              e.stopPropagation();
              handleOpenChat(instruksiItem, penerimaLangsung[0]);
            }}
            sx={{ ml: 0.5 }}
          >
            <ChatIcon fontSize="small" />
          </IconButton>
        </MDBox>
      );
    }

    return (
      <MDBox display="flex" alignItems="center" gap={1}>
        <Button
          variant="contained"
          size="small"
          color="primary"
          onClick={() =>
            handleOpenPenerimaDialog(rincianPenerima, instruksiItem, "langsung")
          }
        >
          {penerimaLangsung.length} Penerima
        </Button>
        <IconButton
          size="small"
          color="primary"
          onClick={(e) => {
            e.stopPropagation();
            // Jika banyak penerima, buka dialog untuk pilih penerima dulu
            handleOpenPenerimaDialog(
              rincianPenerima,
              instruksiItem,
              "langsung"
            );
          }}
          title="Chat dengan penerima"
        >
          <ChatIcon fontSize="small" />
        </IconButton>
      </MDBox>
    );
  };

  // Render penerima lanjutan
  const renderPenerimaLanjutan = (rincianPenerima, instruksiItem) => {
    if (!Array.isArray(rincianPenerima) || rincianPenerima.length === 0) {
      return (
        <MDTypography variant="caption" color="text.secondary">
          -
        </MDTypography>
      );
    }

    const penerimaLanjutan = rincianPenerima.filter(
      (p) => p.asal_perintah_dari_id !== userId
    );

    if (penerimaLanjutan.length === 0) {
      return (
        <MDTypography variant="caption" color="text.secondary">
          -
        </MDTypography>
      );
    }

    if (penerimaLanjutan.length === 1) {
      return (
        <MDBox
          display="flex"
          alignItems="center"
          onClick={() =>
            handleOpenPenerimaDialog(rincianPenerima, instruksiItem, "lanjutan")
          }
          sx={{ cursor: "pointer" }}
        >
          <MDAvatar
            src={
              penerimaLanjutan[0].uid_RSS
                ? `https://smartdh.rotendaokab.go.id/uploads/${penerimaLanjutan[0].uid_RSS}.jpg`
                : undefined
            }
            alt={penerimaLanjutan[0].nama}
            size="sm"
            sx={{ mr: 1 }}
          />
          <MDTypography variant="button" fontWeight="medium">
            {penerimaLanjutan[0].nama}
          </MDTypography>
        </MDBox>
      );
    }

    return (
      <Button
        variant="outlined"
        size="small"
        onClick={() =>
          handleOpenPenerimaDialog(rincianPenerima, instruksiItem, "lanjutan")
        }
        sx={{
          backgroundColor: "#ffffff",
          color: "#000000",
          borderColor: "#000000",
          "&:hover": {
            backgroundColor: "#f5f5f5",
            borderColor: "#000000",
            color: "#000000",
          },
        }}
      >
        {penerimaLanjutan.length} Penerima
      </Button>
    );
  };

  const renderDokumen = (dokumen) => {
    if (!dokumen) {
      return (
        <MDTypography variant="caption" color="text">
          -
        </MDTypography>
      );
    }
    let dokumenArr = [];
    if (Array.isArray(dokumen)) {
      dokumenArr = dokumen;
    } else if (typeof dokumen === "string" && dokumen.trim().startsWith("[")) {
      try {
        dokumenArr = JSON.parse(dokumen);
      } catch (e) {
        dokumenArr = [];
      }
    }
    if (dokumenArr.length === 0) {
      return (
        <MDTypography variant="caption" color="text">
          -
        </MDTypography>
      );
    }
    return (
      <MDBox display="flex" alignItems="center" gap={0.5}>
        <DescriptionIcon sx={{ fontSize: 16, color: "#1565c0" }} />
        <MDTypography variant="caption" color="text">
          Dok Instruksi: {dokumenArr.length}
        </MDTypography>
        {dokumenArr.map((file, idx) => {
          const fileName =
            typeof file === "string" ? file.split("/").pop() : `Dok ${idx + 1}`;
          const fileExt = fileName?.split(".").pop()?.toLowerCase() || "";
          const isPdf = fileExt === "pdf";
          return (
            <IconButton
              key={idx}
              size="small"
              onClick={() => handleOpenFile(file)}
              sx={{ p: 0.5 }}
              title={fileName}
            >
              {isPdf ? (
                <PictureAsPdfIcon sx={{ fontSize: 14, color: "#f44336" }} />
              ) : (
                (() => {
                  const ext = fileExt;
                  if (
                    [
                      "png",
                      "jpg",
                      "jpeg",
                      "gif",
                      "bmp",
                      "svg",
                      "webp",
                    ].includes(ext)
                  )
                    return (
                      <ImageIcon sx={{ fontSize: 14, color: "#1976d2" }} />
                    );
                  if (["doc", "docx"].includes(ext))
                    return (
                      <DescriptionIcon
                        sx={{ fontSize: 14, color: "#1565c0" }}
                      />
                    );
                  if (["xls", "xlsx"].includes(ext))
                    return (
                      <DescriptionIcon
                        sx={{ fontSize: 14, color: "#388e3c" }}
                      />
                    );
                  if (["ppt", "pptx"].includes(ext))
                    return (
                      <DescriptionIcon
                        sx={{ fontSize: 14, color: "#ff9800" }}
                      />
                    );
                  return (
                    <InsertDriveFileIcon
                      sx={{ fontSize: 14, color: "#757575" }}
                    />
                  );
                })()
              )}
            </IconButton>
          );
        })}
      </MDBox>
    );
  };

  // Render dokumen hanya icon saja
  const renderDokumenIcon = (dokumen) => {
    if (!dokumen) {
      return (
        <MDTypography variant="caption" color="text">
          -
        </MDTypography>
      );
    }
    let dokumenArr = [];
    if (Array.isArray(dokumen)) {
      dokumenArr = dokumen;
    } else if (typeof dokumen === "string" && dokumen.trim().startsWith("[")) {
      try {
        dokumenArr = JSON.parse(dokumen);
      } catch (e) {
        dokumenArr = [];
      }
    }
    if (dokumenArr.length === 0) {
      return (
        <MDTypography variant="caption" color="text">
          -
        </MDTypography>
      );
    }
    return (
      <MDBox display="flex" alignItems="center" gap={0.5}>
        {dokumenArr.map((file, idx) => {
          const fileName =
            typeof file === "string" ? file.split("/").pop() : `Dok ${idx + 1}`;
          const fileExt = fileName?.split(".").pop()?.toLowerCase() || "";
          const isPdf = fileExt === "pdf";
          return (
            <IconButton
              key={idx}
              size="small"
              onClick={() => handleOpenFile(file)}
              sx={{ p: 0.5 }}
              title={fileName}
            >
              {isPdf ? (
                <PictureAsPdfIcon sx={{ fontSize: 16, color: "#f44336" }} />
              ) : (
                (() => {
                  const ext = fileExt;
                  if (
                    [
                      "png",
                      "jpg",
                      "jpeg",
                      "gif",
                      "bmp",
                      "svg",
                      "webp",
                    ].includes(ext)
                  )
                    return (
                      <ImageIcon sx={{ fontSize: 16, color: "#1976d2" }} />
                    );
                  if (["doc", "docx"].includes(ext))
                    return (
                      <DescriptionIcon
                        sx={{ fontSize: 16, color: "#1565c0" }}
                      />
                    );
                  if (["xls", "xlsx"].includes(ext))
                    return (
                      <DescriptionIcon
                        sx={{ fontSize: 16, color: "#388e3c" }}
                      />
                    );
                  if (["ppt", "pptx"].includes(ext))
                    return (
                      <DescriptionIcon
                        sx={{ fontSize: 16, color: "#ff9800" }}
                      />
                    );
                  return (
                    <InsertDriveFileIcon
                      sx={{ fontSize: 16, color: "#757575" }}
                    />
                  );
                })()
              )}
            </IconButton>
          );
        })}
      </MDBox>
    );
  };

  // Render icon Approved
  const renderApproved = (rincianPenerima, pengirimId) => {
    const isApproved = isInstruksiApproved(rincianPenerima, pengirimId);
    if (!isApproved) {
      return (
        <MDTypography variant="caption" color="text.secondary">
          -
        </MDTypography>
      );
    }
    return (
      <CheckCircleIcon
        sx={{
          color: "#00c875",
          fontSize: "1.5rem",
        }}
        titleAccess="Approved"
      />
    );
  };

  // Render Respon (menggabungkan ketepatan waktu dan approved status)
  const renderRespon = (item, rincianPenerima, pengirimId) => {
    const isApproved = isInstruksiApproved(rincianPenerima, pengirimId);

    if (isApproved) {
      // Jika approved, tampilkan icon approved + teks "Approved" + ketepatan waktu
      const ketepatanWaktu = renderKetepatanWaktu(item);
      return (
        <MDBox display="flex" flexDirection="column" gap={0.5}>
          <MDBox display="flex" alignItems="center" gap={0.5}>
            <CheckCircleIcon
              sx={{
                color: "#00c875",
                fontSize: "1.2rem",
              }}
            />
            <MDTypography variant="caption" color="success" fontWeight="medium">
              Approved
            </MDTypography>
          </MDBox>
          {ketepatanWaktu}
        </MDBox>
      );
    } else {
      // Jika belum approved, tampilkan icon waiting + teks "waiting" + ketepatan waktu
      const ketepatanWaktu = renderKetepatanWaktu(item);
      return (
        <MDBox display="flex" flexDirection="column" gap={0.5}>
          <MDBox display="flex" alignItems="center" gap={0.5}>
            <HourglassBottomIcon
              sx={{
                color: "#ffb300",
                fontSize: "1.2rem",
              }}
            />
            <MDTypography variant="caption" color="warning" fontWeight="medium">
              Waiting
            </MDTypography>
          </MDBox>
          {ketepatanWaktu}
        </MDBox>
      );
    }
  };

  // Hanya menghitung penerima langsung (asal_perintah_dari_id === pengirimId)
  const renderStatus = (item, pengirimId) => {
    if (!Array.isArray(item.rincian_penerima)) {
      return (
        <Chip
          label="Belum dikerjakan"
          size="small"
          sx={{
            backgroundColor: "#bdbdbd",
            color: "white",
            fontWeight: 600,
            fontSize: "0.7rem",
            height: "24px",
          }}
        />
      );
    }

    // Filter hanya penerima langsung (asal_perintah_dari_id === pengirimId)
    const penerimaLangsung = item.rincian_penerima.filter(
      (p) => p.asal_perintah_dari_id === pengirimId
    );

    if (penerimaLangsung.length === 0) {
      return (
        <Chip
          label="Tidak ada penerima langsung"
          size="small"
          sx={{
            backgroundColor: "#bdbdbd",
            color: "white",
            fontWeight: 600,
            fontSize: "0.7rem",
            height: "24px",
          }}
        />
      );
    }

    const totalPenerima = penerimaLangsung.length;
    const selesaiCount = penerimaLangsung.filter(
      (p) => (p.status || "").toLowerCase() === "selesai"
    ).length;

    let statusLabel = "Belum dikerjakan";
    let statusColor = "#bdbdbd";
    if (selesaiCount === 0) {
      statusLabel = "Belum dikerjakan";
      statusColor = "#bdbdbd";
    } else if (selesaiCount > 0 && selesaiCount < totalPenerima) {
      statusLabel = "On Progress";
      statusColor = "#ffb300";
    } else if (selesaiCount === totalPenerima && totalPenerima > 0) {
      statusLabel = "Completed";
      statusColor = "#4caf50";
    }
    return (
      <Chip
        label={statusLabel}
        size="small"
        sx={{
          backgroundColor: statusColor,
          color: "white",
          fontWeight: 600,
          fontSize: "0.7rem",
          height: "24px",
        }}
      />
    );
  };

  const renderKetepatanWaktu = (item) => {
    if (!item.tanggal_selesai) {
      return (
        <MDTypography variant="caption" color="text.secondary">
          -
        </MDTypography>
      );
    }

    const deadline = new Date(item.tanggal_selesai);
    const now = new Date();

    // Cek apakah instruksi sudah selesai (semua penerima langsung selesai)
    const penerimaLangsung = Array.isArray(item.rincian_penerima)
      ? item.rincian_penerima.filter((p) => p.asal_perintah_dari_id === userId)
      : [];

    const isCompleted =
      penerimaLangsung.length > 0 &&
      penerimaLangsung.every(
        (p) => (p.status || "").toLowerCase() === "selesai"
      );

    if (isCompleted) {
      // Instruksi sudah selesai - cek apakah tepat waktu
      // Ambil waktu selesai terakhir dari penerima langsung
      const waktuSelesaiList = penerimaLangsung
        .map((p) => p.waktu_selesai)
        .filter((w) => w && w !== null && w !== "")
        .map((w) => {
          const date = new Date(w);
          return isNaN(date.getTime()) ? null : date;
        })
        .filter((d) => d !== null);

      if (waktuSelesaiList.length === 0) {
        return (
          <MDTypography variant="caption" color="text.secondary">
            -
          </MDTypography>
        );
      }

      const waktuSelesaiTerakhir = new Date(
        Math.max(...waktuSelesaiList.map((d) => d.getTime()))
      );

      // Set deadline ke akhir hari (23:59:59) untuk perbandingan yang lebih akurat
      const deadlineEndOfDay = new Date(deadline);
      deadlineEndOfDay.setHours(23, 59, 59, 999);

      // Bandingkan waktu selesai dengan deadline
      if (waktuSelesaiTerakhir <= deadlineEndOfDay) {
        // Tepat waktu
        return (
          <MDTypography variant="caption" color="success" fontWeight="medium">
            Tepat Waktu
          </MDTypography>
        );
      } else {
        // Melewati waktu - hitung selisih
        const diffMs = waktuSelesaiTerakhir - deadlineEndOfDay;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const diffHours = Math.floor(
          (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );

        let label = "Melewati Waktu";
        if (diffDays > 0) {
          label += ` ${diffDays} hari`;
        }
        if (diffHours > 0) {
          label += ` ${diffHours} jam`;
        }
        if (diffDays === 0 && diffHours === 0) {
          const diffMinutes = Math.floor(
            (diffMs % (1000 * 60 * 60)) / (1000 * 60)
          );
          if (diffMinutes > 0) {
            label += ` ${diffMinutes} menit`;
          }
        }

        return (
          <MDTypography variant="caption" color="error" fontWeight="medium">
            {label}
          </MDTypography>
        );
      }
    } else {
      // Instruksi belum selesai - cek apakah lewat deadline
      // Set deadline ke akhir hari (23:59:59) untuk perbandingan
      const deadlineEndOfDay = new Date(deadline);
      deadlineEndOfDay.setHours(23, 59, 59, 999);

      if (now > deadlineEndOfDay) {
        // Melewati waktu - hitung selisih dari deadline ke sekarang
        const diffMs = now - deadlineEndOfDay;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const diffHours = Math.floor(
          (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );

        let label = "Melewati Waktu";
        if (diffDays > 0) {
          label += ` ${diffDays} hari`;
        }
        if (diffHours > 0) {
          label += ` ${diffHours} jam`;
        }
        if (diffDays === 0 && diffHours === 0) {
          const diffMinutes = Math.floor(
            (diffMs % (1000 * 60 * 60)) / (1000 * 60)
          );
          if (diffMinutes > 0) {
            label += ` ${diffMinutes} menit`;
          }
        }

        return (
          <MDTypography variant="caption" color="error" fontWeight="medium">
            {label}
          </MDTypography>
        );
      } else {
        // Belum lewat deadline - tidak perlu menampilkan apa-apa atau tampilkan info
        return (
          <MDTypography variant="caption" color="text.secondary">
            -
          </MDTypography>
        );
      }
    }
  };

  // Fungsi untuk render card penerima
  const renderPenerimaCard = (penerima, instruksiItem = null) => {
    const isCompleted =
      penerima.status && penerima.status.toLowerCase() === "selesai";
    const isInProgress =
      penerima.status &&
      (penerima.status.toLowerCase() === "proses" ||
        penerima.status.toLowerCase() === "on progress");

    // Parse file_tindak_lanjut
    let fileTLArr = [];
    if (penerima.file) {
      if (Array.isArray(penerima.file)) {
        fileTLArr = penerima.file;
      } else if (
        typeof penerima.file === "string" &&
        penerima.file.trim().startsWith("[")
      ) {
        try {
          fileTLArr = JSON.parse(penerima.file);
        } catch (e) {
          fileTLArr = [];
        }
      } else if (typeof penerima.file === "string") {
        fileTLArr = [penerima.file];
      }
    }

    // Cek apakah penerima adalah penerima langsung (untuk menampilkan icon chat)
    const isPenerimaLangsung = penerima.asal_perintah_dari_id === userId;

    return (
      <Card>
        <CardContent>
          {/* Asal Perintah */}
          {penerima.asal_perintah_nama && (
            <MDBox mb={2}>
              <MDBox display="flex" alignItems="center" gap={1.5} mb={1}>
                <MDAvatar
                  src={
                    penerima.instruksi?.asal_perintah_dari?.uid_RSS ||
                    penerima.asal_perintah_uid_RSS
                      ? `https://smartdh.rotendaokab.go.id/uploads/${
                          penerima.instruksi?.asal_perintah_dari?.uid_RSS ||
                          penerima.asal_perintah_uid_RSS
                        }.jpg`
                      : undefined
                  }
                  alt={penerima.asal_perintah_nama}
                  size="sm"
                />
                <MDBox>
                  <MDTypography
                    variant="caption"
                    color="text.secondary"
                    fontWeight="medium"
                  >
                    Asal Perintah:
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    {penerima.asal_perintah_nama}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox display="flex" alignItems="center" gap={1}>
                <ArrowForwardIcon
                  sx={{ fontSize: 20, color: "text.secondary" }}
                />
                <MDTypography variant="caption" color="text.secondary">
                  Penerima Instruksi
                </MDTypography>
              </MDBox>
            </MDBox>
          )}

          {/* Penerima Instruksi */}
          <MDBox mb={1}>
            <MDBox display="flex" alignItems="center" gap={1.5} mb={1}>
              <MDAvatar
                src={
                  penerima.instruksi?.penerima?.uid_RSS || penerima.uid_RSS
                    ? `https://smartdh.rotendaokab.go.id/uploads/${
                        penerima.instruksi?.penerima?.uid_RSS ||
                        penerima.uid_RSS
                      }.jpg`
                    : undefined
                }
                alt={penerima.nama}
                size="sm"
              />
              <MDBox sx={{ flex: 1 }}>
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  fontWeight="medium"
                >
                  Penerima:
                </MDTypography>
                <MDBox display="flex" alignItems="center" gap={1}>
                  <MDTypography variant="body2" color="text">
                    {penerima.nama}
                  </MDTypography>
                  {/* Icon Chat - hanya tampil untuk penerima langsung jika ada instruksiItem */}
                  {isPenerimaLangsung && instruksiItem && (
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClosePenerimaDialog();
                        setTimeout(() => {
                          handleOpenChat(instruksiItem, penerima);
                        }, 100);
                      }}
                      sx={{ ml: 0.5 }}
                      title="Chat dengan penerima"
                    >
                      <ChatIcon fontSize="small" />
                    </IconButton>
                  )}
                  {/* Icon WhatsApp - kirim instruksi ke nomor penerima (hanya penerima langsung) */}
                  {isPenerimaLangsung &&
                    instruksiItem &&
                    buildWhatsAppUrl(penerima.noHP, instruksiItem) && (
                      <MDBox
                        component="a"
                        href={buildWhatsAppUrl(penerima.noHP, instruksiItem)}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        display="inline-flex"
                        alignItems="center"
                        gap={0.5}
                        sx={{
                          ml: 0.5,
                          color: "#25D366",
                          textDecoration: "none",
                          cursor: "pointer",
                          "&:hover": { color: "#128C7E" },
                        }}
                        title="Kirim instruksi via WhatsApp"
                      >
                        <IconButton
                          size="small"
                          sx={{
                            color: "inherit",
                            p: 0.25,
                            "&:hover": {
                              bgcolor: "rgba(37,211,102,0.08)",
                            },
                          }}
                        >
                          <WhatsAppIcon fontSize="small" />
                        </IconButton>
                        <MDTypography variant="caption" color="inherit" sx={{ fontWeight: 500 }}>
                          kirim instruksi lewat
                        </MDTypography>
                      </MDBox>
                    )}
                </MDBox>
              </MDBox>
            </MDBox>
          </MDBox>

          {/* Tingkat Perintah */}
          {penerima.tingkat && (
            <MDBox mb={1}>
              <MDTypography
                variant="caption"
                color="text.secondary"
                fontWeight="medium"
              >
                Tingkat Perintah:
              </MDTypography>
              <MDTypography variant="body2" color="text">
                Level {penerima.tingkat}
              </MDTypography>
            </MDBox>
          )}

          {/* Status */}
          <MDBox mb={1}>
            <MDTypography
              variant="caption"
              color="text.secondary"
              fontWeight="medium"
              mb={0.5}
            >
              Status:
            </MDTypography>
            <MDBox display="flex" gap={1} flexWrap="wrap">
              {isCompleted ? (
                <Chip
                  icon={<CheckCircleIcon />}
                  label="Selesai"
                  color="success"
                  size="small"
                />
              ) : isInProgress ? (
                <Chip
                  icon={<HourglassBottomIcon />}
                  label="Proses"
                  color="warning"
                  size="small"
                />
              ) : (
                <Chip
                  icon={<CancelIcon />}
                  label="Belum"
                  color="error"
                  size="small"
                />
              )}
            </MDBox>
          </MDBox>

          {/* Waktu Diterima */}
          {penerima.waktu_diterima && (
            <MDBox mb={1}>
              <MDTypography
                variant="caption"
                color="text.secondary"
                fontWeight="medium"
              >
                Waktu Diterima:
              </MDTypography>
              <MDTypography variant="body2" color="text">
                {formatDateTime(penerima.waktu_diterima)}
              </MDTypography>
            </MDBox>
          )}

          {/* Waktu Selesai */}
          {isCompleted && penerima.waktu_selesai && (
            <MDBox mb={1}>
              <MDTypography
                variant="caption"
                color="text.secondary"
                fontWeight="medium"
              >
                Waktu Selesai:
              </MDTypography>
              <MDTypography variant="body2" color="text">
                {formatDateTime(penerima.waktu_selesai)}
              </MDTypography>
            </MDBox>
          )}

          {/* Waktu Diselesaikan */}
          {isCompleted && penerima.waktu_diselesaikan && (
            <MDBox mb={1}>
              <MDTypography
                variant="caption"
                color="text.secondary"
                fontWeight="medium"
              >
                Waktu Diselesaikan:
              </MDTypography>
              <MDTypography variant="body2" color="text">
                {formatDateTime(penerima.waktu_diselesaikan)}
              </MDTypography>
            </MDBox>
          )}

          {/* Catatan Selesai */}
          {isCompleted && penerima.catatan_selesai && (
            <MDBox
              mt={1.5}
              sx={{
                p: 1,
                background: "#f0f7ff",
                borderRadius: 1,
                border: "1px solid #b3d9ff",
              }}
            >
              <MDTypography
                variant="caption"
                color="text"
                fontWeight="600"
                sx={{
                  display: "block",
                  mb: 0.5,
                  fontSize: "0.6rem",
                }}
              >
                Catatan Selesai:
              </MDTypography>
              <MDTypography
                variant="caption"
                color="dark"
                sx={{
                  fontSize: "0.65rem",
                  lineHeight: 1.4,
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {renderTextWithLinks(penerima.catatan_selesai)}
              </MDTypography>
            </MDBox>
          )}

          {/* File Tindak Lanjut */}
          <MDBox mb={1}>
            <MDTypography
              variant="caption"
              color="text.secondary"
              fontWeight="medium"
              mb={0.5}
            >
              File Tindak Lanjut ({fileTLArr.length}):
            </MDTypography>
            {fileTLArr.length > 0 ? (
              <MDBox display="flex" flexDirection="column" gap={1}>
                {fileTLArr.map((file, idx) => {
                  const filename = file.split("/").pop();
                  return (
                    <Button
                      key={idx}
                      onClick={() => handleOpenFile(file)}
                      variant="contained"
                      size="small"
                      startIcon={getFileIcon(filename)}
                      sx={{ justifyContent: "flex-start" }}
                    >
                      {filename}
                    </Button>
                  );
                })}
              </MDBox>
            ) : (
              <MDTypography variant="body2" color="text.secondary">
                Belum ada file tindak lanjut
              </MDTypography>
            )}
          </MDBox>

          {/* Catatan Tindak Lanjut */}
          {penerima.instruksi_tindak_lanjut && (
            <MDBox
              mt={1.5}
              sx={{
                p: 1,
                background: "#f8f9fa",
                borderRadius: 1,
                border: "1px solid #e9ecef",
              }}
            >
              <MDTypography
                variant="caption"
                color="text"
                fontWeight="600"
                sx={{
                  display: "block",
                  mb: 0.5,
                  fontSize: "0.6rem",
                }}
              >
                Catatan Tindak Lanjut:
              </MDTypography>
              <MDTypography
                variant="caption"
                color="dark"
                sx={{
                  fontSize: "0.65rem",
                  lineHeight: 1.4,
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {penerima.instruksi_tindak_lanjut}
              </MDTypography>
            </MDBox>
          )}

          {/* Respon Pemberi Instruksi - hanya tampil jika status Selesai dan waktu_diselesaikan terisi */}
          {isCompleted && penerima.waktu_diselesaikan && isPenerimaLangsung && (
            <MDBox mt={2}>
              {/* Tampilkan respon jika sudah ada */}
              {penerima.respon_pemberi_instruksi && (
                <MDBox
                  sx={{
                    p: 1.5,
                    background: "#f0f7ff",
                    borderRadius: 1,
                    border: "1px solid #b3d9ff",
                    mb: 2,
                  }}
                >
                  <MDBox
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={1}
                  >
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <MDTypography
                        variant="caption"
                        color="text.secondary"
                        fontWeight="600"
                      >
                        Respon Anda:
                      </MDTypography>
                      <Chip
                        label={penerima.respon_pemberi_instruksi}
                        size="small"
                        color={
                          penerima.respon_pemberi_instruksi === "Terima"
                            ? "success"
                            : penerima.respon_pemberi_instruksi === "Tolak"
                            ? "error"
                            : "warning"
                        }
                        sx={{ fontWeight: 600 }}
                      />
                    </MDBox>
                    {/* Tombol Edit Respon */}
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => handleOpenResponDialog(penerima)}
                      sx={{
                        p: 0.5,
                        "&:hover": {
                          backgroundColor: "rgba(25, 118, 210, 0.08)",
                        },
                      }}
                      title="Edit Respon"
                    >
                      <Icon sx={{ fontSize: "18px" }}>edit</Icon>
                    </IconButton>
                  </MDBox>
                  {penerima.respon_pemberi_instruksi === "Terima" &&
                    penerima.nilai && (
                      <MDBox display="flex" alignItems="center" gap={0.5}>
                        <MDTypography
                          variant="caption"
                          color="text.secondary"
                          fontWeight="600"
                        >
                          Penilaian:
                        </MDTypography>
                        {[1, 2, 3, 4, 5].map((rating) => (
                          <Icon
                            key={rating}
                            sx={{
                              fontSize: "20px",
                              color:
                                penerima.nilai >= rating
                                  ? "#FFD700"
                                  : "#E0E0E0",
                            }}
                          >
                            star
                          </Icon>
                        ))}
                        <MDTypography
                          variant="caption"
                          color="text.secondary"
                          ml={0.5}
                        >
                          ({penerima.nilai} bintang)
                        </MDTypography>
                      </MDBox>
                    )}
                </MDBox>
              )}

              {/* Tombol respon muncul jika belum ada respon, atau jika respon adalah Perbaiki/Tolak */}
              {(!penerima.respon_pemberi_instruksi ||
                penerima.respon_pemberi_instruksi === "Perbaiki" ||
                penerima.respon_pemberi_instruksi === "Tolak") && (
                <MDButton
                  variant="gradient"
                  color="info"
                  size="small"
                  onClick={() => handleOpenResponDialog(penerima)}
                  startIcon={<Icon>rate_review</Icon>}
                  fullWidth
                >
                  {penerima.respon_pemberi_instruksi
                    ? "Ubah Respon"
                    : "Berikan Respon"}
                </MDButton>
              )}
            </MDBox>
          )}
        </CardContent>
      </Card>
    );
  };

  // Data tabel berdasarkan activeFilter (Total, Selesai, Dalam Proses, dll)
  const filteredTableData = useMemo(() => {
    const today = new Date();
    let data = [];

    switch (activeFilter) {
      case "total":
        data = [...instruksiFilteredByYear];
        break;
      case "selesai":
        data = [...instruksiUntukSelesai];
        break;
      case "selesaibelumrating":
        data = [...instruksiSelesaiBelumRating];
        break;
      case "dalamproses":
        data = instruksiOleh.filter((item) => {
          if (!Array.isArray(item.rincian_penerima)) return false;
          const penerimaLangsung = item.rincian_penerima.filter(
            (p) => p.asal_perintah_dari_id === userId
          );
          if (penerimaLangsung.length === 0) return false;
          const totalPenerima = penerimaLangsung.length;
          const selesaiCount = penerimaLangsung.filter(
            (p) => (p.status || "").toLowerCase() === "selesai"
          ).length;
          return selesaiCount > 0 && selesaiCount < totalPenerima;
        });
        break;
      case "belumdimulai":
        data = instruksiOleh.filter((item) => {
          if (!Array.isArray(item.rincian_penerima)) return false;
          const penerimaLangsung = item.rincian_penerima.filter(
            (p) => p.asal_perintah_dari_id === userId
          );
          if (penerimaLangsung.length === 0) return false;
          const selesaiCount = penerimaLangsung.filter(
            (p) => (p.status || "").toLowerCase() === "selesai"
          ).length;
          return selesaiCount === 0;
        });
        break;
      case "lewatdeadline":
        data = instruksiOleh.filter((item) => {
          if (!item.tanggal_selesai) return false;
          const tglSelesai = new Date(item.tanggal_selesai);
          const diffTime =
            tglSelesai.setHours(0, 0, 0, 0) - today.setHours(0, 0, 0, 0);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          return diffDays < 0;
        });
        break;
      default:
        data = [...instruksiFilteredByYear];
    }

    return data.sort((a, b) => {
      const dateA = a.tanggal ? new Date(a.tanggal) : new Date(0);
      const dateB = b.tanggal ? new Date(b.tanggal) : new Date(0);
      return dateB - dateA;
    });
  }, [
    activeFilter,
    instruksiFilteredByYear,
    instruksiUntukSelesai,
    instruksiSelesaiBelumRating,
    instruksiOleh,
    userId,
  ]);

  // Prepare data untuk tabel (dengan filter search)
  const tableData = useMemo(() => {
    let data = filteredTableData.map((item) => ({ ...item }));

    if (searchInput && searchInput.trim()) {
      const q = searchInput.trim().toLowerCase();
      const stripHtml = (html) => {
        if (!html || typeof html !== "string") return "";
        return html.replace(/<[^>]*>/g, "").toLowerCase();
      };
      data = data.filter((item) => {
        const perihal = (item.perihal || "").toLowerCase();
        const isiInstruksi = stripHtml(item.isi_instruksi || "");
        const penerimaNames = (item.rincian_penerima || [])
          .map((p) => (p.nama || "").toLowerCase())
          .join(" ");
        return (
          perihal.includes(q) ||
          isiInstruksi.includes(q) ||
          penerimaNames.includes(q)
        );
      });
    }

    return data;
  }, [filteredTableData, searchInput]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox mt={4}>
        {/* Card Filter & Search */}
        <Card
          sx={{
            mb: 3,
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            borderRadius: 2,
            border: "1px solid #e8e8e8",
            overflow: "visible",
          }}
        >
          <MDBox p={2.5}>
            {/* Baris 1: Filter Tahun + Search */}
            <MDBox
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              gap={2}
              alignItems={{ xs: "stretch", sm: "center" }}
              mb={2}
            >
              <MDBox
                display="flex"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{ minWidth: { sm: 200 } }}
              >
                <Autocomplete
                  options={Array.from(
                    { length: new Date().getFullYear() - 2024 + 1 },
                    (_, i) => ({
                      label: (new Date().getFullYear() - i).toString(),
                      value: new Date().getFullYear() - i,
                    })
                  )}
                  value={
                    tahun
                      ? {
                          label: tahun.toString(),
                          value: tahun,
                        }
                      : null
                  }
                  onChange={(event, newValue) => {
                    setTahun(newValue ? newValue.value : null);
                  }}
                  getOptionLabel={(option) =>
                    typeof option === "object" ? option.label : option.toString()
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  }
                  renderInput={(params) => (
                    <MDInput {...params} label="Tahun" sx={{ minWidth: 120 }} />
                  )}
                  sx={{ minWidth: 120 }}
                />
              </MDBox>
              <MDBox flex={1} sx={{ minWidth: 0 }}>
                <MDInput
                  placeholder="Cari perihal, isi instruksi, atau penerima..."
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: "text.secondary" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </MDBox>
            </MDBox>

            {/* Baris 2: Chips Status */}
            <MDBox
              display="flex"
              flexWrap="wrap"
              gap={1.5}
              alignItems="center"
              pt={1}
              sx={{ borderTop: "1px solid #eee" }}
            >
              {/* Total (filter tahun) */}
              <Chip
                label={`Total: ${instruksiFilteredByYear.length}`}
                color="info"
                size="medium"
                icon={<Icon>edit_note</Icon>}
                variant={activeFilter === "total" ? "filled" : "outlined"}
                onClick={() => setActiveFilter("total")}
                sx={{
                  fontSize: "0.875rem",
                  fontWeight: "medium",
                  px: 1,
                  cursor: "pointer",
                  ...(activeFilter !== "total" && {
                    backgroundColor: "#fff",
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    "& .MuiChip-icon": { color: "#1976d2" },
                  }),
                }}
              />

            {(() => {
              // Selesai: filter tahun terpilih
              const selesaiCount = instruksiUntukSelesai.length;

              // Proses, Belum, Lewat: tanpa filter tahun (semua data)
              const statusStats = { proses: 0, belum: 0, lewat: 0 };
              const today = new Date();
              instruksiOleh.forEach((item) => {
                if (Array.isArray(item.rincian_penerima)) {
                  // Filter hanya penerima langsung
                  const penerimaLangsung = item.rincian_penerima.filter(
                    (p) => p.asal_perintah_dari_id === userId
                  );

                  if (penerimaLangsung.length === 0) return;

                  const totalPenerima = penerimaLangsung.length;
                  const selesaiCount = penerimaLangsung.filter(
                    (p) => (p.status || "").toLowerCase() === "selesai"
                  ).length;

                  if (selesaiCount === totalPenerima && totalPenerima > 0) {
                    // Selesai dihitung dari instruksiUntukSelesai
                  } else if (selesaiCount > 0) {
                    statusStats.proses++;
                  } else {
                    statusStats.belum++;
                  }

                  // Cek deadline
                  if (item.tanggal_selesai) {
                    const tglSelesai = new Date(item.tanggal_selesai);
                    const diffTime =
                      tglSelesai.setHours(0, 0, 0, 0) -
                      today.setHours(0, 0, 0, 0);
                    const diffDays = Math.ceil(
                      diffTime / (1000 * 60 * 60 * 24)
                    );
                    if (diffDays < 0) {
                      statusStats.lewat++;
                    }
                  }
                }
              });

              const colorMap = {
                success: "#2e7d32",
                secondary: "#9c27b0",
                warning: "#ed6c02",
                error: "#d32f2f",
                info: "#1976d2",
              };

              const selesaiBelumRatingCount = instruksiSelesaiBelumRating.length;

              const statusItems = [
                {
                  label: "Selesai",
                  count: selesaiCount,
                  color: "success",
                  icon: "check_circle",
                  statusKey: "selesai",
                },
                {
                  label: "Belum Rating",
                  count: selesaiBelumRatingCount,
                  color: "secondary",
                  icon: "star_outline",
                  statusKey: "selesaibelumrating",
                },
                {
                  label: "Dalam Proses",
                  count: statusStats.proses,
                  color: "warning",
                  icon: "pending",
                  statusKey: "dalamproses",
                },
                {
                  label: "Belum Dimulai",
                  count: statusStats.belum,
                  color: "error",
                  icon: "schedule",
                  statusKey: "belumdimulai",
                },
                {
                  label: "Lewat Deadline",
                  count: statusStats.lewat,
                  color: "info",
                  icon: "warning",
                  statusKey: "lewatdeadline",
                },
              ];

              return statusItems.map((item) => {
                const chipColor = colorMap[item.color] || "#666";
                return (
                  <Chip
                    key={item.label}
                    label={`${item.label}: ${item.count}`}
                    color={item.color}
                    size="medium"
                    icon={<Icon>{item.icon}</Icon>}
                    variant={activeFilter === item.statusKey ? "filled" : "outlined"}
                    onClick={() => setActiveFilter(item.statusKey)}
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: "medium",
                      px: 1,
                      cursor: "pointer",
                      ...(activeFilter !== item.statusKey && {
                        backgroundColor: "#fff",
                        borderColor: chipColor,
                        color: chipColor,
                        "& .MuiChip-icon": { color: chipColor },
                      }),
                    }}
                  />
                );
              });
            })()}
            </MDBox>
          </MDBox>
        </Card>

        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sx={{ background: "#fff" }}>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={3}
                p={3}
                variant="gradient"
                bgColor="info"
                color="white"
                borderRadius="lg"
                boxShadow="lg"
              >
                <MDTypography variant="h5" fontWeight="bold" color="white">
                  Daftar Instruksi Oleh Anda
                </MDTypography>
                <MDButton
                  variant="outlined"
                  onClick={() =>
                    navigate("/task-management/tugas/instruksi-baru")
                  }
                  sx={{
                    boxShadow: 1,
                    borderRadius: 2,
                    fontWeight: "bold",
                    textTransform: "none",
                    px: 3,
                    py: 1.5,
                    backgroundColor: "#ffffff",
                    color: "#000000",
                    border: "1px solid #000000",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                      borderColor: "#000000",
                      color: "#000000",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  <Icon sx={{ fontWeight: "bold", mr: 1, color: "#000000" }}>
                    add
                  </Icon>
                  Buat Instruksi
                </MDButton>
              </MDBox>

              {/* Loading Spinner */}
              {loading ? (
                <MDBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  py={4}
                >
                  <CircularProgress />
                </MDBox>
              ) : (
                <>
                  {tableData.length === 0 && (
                    <MDTypography variant="body2" color="text">
                      {searchInput.trim()
                        ? "Tidak ada instruksi yang cocok dengan pencarian."
                        : activeFilter === "total"
                        ? "Belum ada instruksi untuk tahun terpilih."
                        : activeFilter === "selesai"
                        ? "Tidak ada instruksi selesai untuk tahun terpilih."
                        : activeFilter === "selesaibelumrating"
                        ? "Tidak ada instruksi yang belum dirating."
                        : "Tidak ada instruksi dengan status ini."}
                    </MDTypography>
                  )}
                  {tableData.length > 0 && (
                    <>
                      <Grid container spacing={2} sx={{ px: { xs: 2, sm: 3 }, pb: 3 }}>
                        {tableData.map((item, index) => {
                          const perihalText =
                            stripHtmlTextInstruksi(item.perihal || "") || "-";
                          const isiText =
                            stripHtmlTextInstruksi(item.isi_instruksi || "") ||
                            "-";
                          const prioritas = item.prioritas || "-";
                          const selesai = isInstruksiSelesai(item, userId);
                          const uidPembuat =
                            item.pengirim?.uid_RSS ||
                            item.instruksi_asal?.pengirim?.uid_RSS;
                          const pengirimSrc = uidPembuat
                            ? `https://smartdh.rotendaokab.go.id/uploads/${uidPembuat}.jpg`
                            : undefined;
                          return (
                            <Grid item xs={12} sm={6} lg={4} key={item.instruksi_id}>
                              <Card
                                sx={{
                                  p: 2,
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                  transition: "box-shadow 0.2s, transform 0.2s",
                                  "&:hover": {
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                                    transform: "translateY(-1px)",
                                  },
                                }}
                              >
                                <MDTypography
                                  variant="caption"
                                  color="text.secondary"
                                  fontWeight="bold"
                                >
                                  #{index + 1}
                                </MDTypography>
                                <MDBox
                                  onClick={() =>
                                    handleOpenPerihalDialog(item.perihal || "-")
                                  }
                                  sx={{
                                    cursor: "pointer",
                                    mb: 0.5,
                                    "&:hover": {
                                      textDecoration: "underline",
                                      color: "primary.main",
                                    },
                                  }}
                                >
                                  <MDTypography
                                    variant="body2"
                                    fontWeight={600}
                                    sx={{
                                      lineHeight: 1.35,
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {perihalText.length > 160
                                      ? `${perihalText.slice(0, 160)}…`
                                      : perihalText}
                                  </MDTypography>
                                </MDBox>
                                <MDBox
                                  onClick={() =>
                                    handleOpenIsiInstruksiDialog(
                                      item.isi_instruksi || "-"
                                    )
                                  }
                                  sx={{
                                    cursor: "pointer",
                                    mb: 1,
                                    "&:hover": {
                                      textDecoration: "underline",
                                      color: "primary.main",
                                    },
                                  }}
                                >
                                  <MDTypography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {isiText.length > 140
                                      ? `${isiText.slice(0, 140)}…`
                                      : isiText}
                                  </MDTypography>
                                </MDBox>
                                <MDBox
                                  display="flex"
                                  gap={1}
                                  flexWrap="wrap"
                                  mb={1.5}
                                >
                                  <Chip
                                    label={prioritas}
                                    size="small"
                                    sx={{
                                      backgroundColor:
                                        PRIORITAS_COLOR[prioritas] || "#9e9e9e",
                                      color: "white",
                                      fontWeight: 600,
                                      fontSize: "0.65rem",
                                    }}
                                  />
                                </MDBox>
                                <MDBox
                                  sx={instruksiListInfoAccentSx(
                                    INSTRUKSI_LIST_ACCENT.blue
                                  )}
                                  mb={1}
                                >
                                  <MDTypography
                                    variant="caption"
                                    sx={{
                                      color: INSTRUKSI_LIST_ACCENT.blue,
                                      fontWeight: 600,
                                      fontSize: "0.65rem",
                                      display: "block",
                                      mb: 0.15,
                                    }}
                                  >
                                    Pembuat instruksi
                                  </MDTypography>
                                  <MDBox
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                  >
                                    <MDAvatar src={pengirimSrc} size="xs" />
                                    <MDTypography
                                      variant="caption"
                                      color="text.secondary"
                                    >
                                      {item.pengirim?.nama || "-"}
                                    </MDTypography>
                                  </MDBox>
                                </MDBox>
                                <MDBox
                                  sx={instruksiListInfoAccentSx(
                                    INSTRUKSI_LIST_ACCENT.green
                                  )}
                                  mb={1}
                                >
                                  <MDTypography
                                    variant="caption"
                                    sx={{
                                      color: INSTRUKSI_LIST_ACCENT.green,
                                      fontWeight: 600,
                                      fontSize: "0.65rem",
                                      display: "block",
                                      mb: 0.15,
                                    }}
                                  >
                                    Mulai
                                  </MDTypography>
                                  <MDTypography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {formatDateTime(item.tanggal)}
                                  </MDTypography>
                                </MDBox>
                                <MDBox
                                  sx={instruksiListInfoAccentSx(
                                    INSTRUKSI_LIST_ACCENT.red
                                  )}
                                  mb={1}
                                >
                                  <MDTypography
                                    variant="caption"
                                    sx={{
                                      color: INSTRUKSI_LIST_ACCENT.red,
                                      fontWeight: 600,
                                      fontSize: "0.65rem",
                                      display: "block",
                                      mb: 0.15,
                                    }}
                                  >
                                    Selesai
                                  </MDTypography>
                                  <MDTypography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {formatDateTime(item.tanggal_selesai)}
                                  </MDTypography>
                                </MDBox>
                                <MDBox
                                  sx={instruksiListInfoAccentSx(
                                    INSTRUKSI_LIST_ACCENT.slate
                                  )}
                                  mb={1}
                                >
                                  <MDTypography
                                    variant="caption"
                                    sx={{
                                      color: INSTRUKSI_LIST_ACCENT.slate,
                                      fontWeight: 600,
                                      fontSize: "0.65rem",
                                      display: "block",
                                      mb: 0.15,
                                    }}
                                  >
                                    Penerima langsung
                                  </MDTypography>
                                  <MDBox sx={{ mt: 0.5 }}>
                                    {renderPenerimaLangsung(
                                      item.rincian_penerima,
                                      item
                                    )}
                                  </MDBox>
                                </MDBox>
                                <MDBox
                                  sx={instruksiListInfoAccentSx(
                                    INSTRUKSI_LIST_ACCENT_ARR[0]
                                  )}
                                  mb={1}
                                >
                                  <MDTypography
                                    variant="caption"
                                    sx={{
                                      color: INSTRUKSI_LIST_ACCENT_ARR[0],
                                      fontWeight: 600,
                                      fontSize: "0.65rem",
                                      display: "block",
                                      mb: 0.15,
                                    }}
                                  >
                                    Progress
                                  </MDTypography>
                                  {renderProgress(
                                    item.rincian_penerima,
                                    userId
                                  )}
                                </MDBox>
                                <MDBox
                                  sx={instruksiListInfoAccentSx(
                                    INSTRUKSI_LIST_ACCENT_ARR[1]
                                  )}
                                  mb={1}
                                >
                                  <MDTypography
                                    variant="caption"
                                    sx={{
                                      color: INSTRUKSI_LIST_ACCENT_ARR[1],
                                      fontWeight: 600,
                                      fontSize: "0.65rem",
                                      display: "block",
                                      mb: 0.15,
                                    }}
                                  >
                                    Status
                                  </MDTypography>
                                  {renderStatus(item, userId)}
                                </MDBox>
                                <MDBox
                                  sx={instruksiListInfoAccentSx(
                                    INSTRUKSI_LIST_ACCENT_ARR[2]
                                  )}
                                  mb={1}
                                >
                                  <MDTypography
                                    variant="caption"
                                    sx={{
                                      color: INSTRUKSI_LIST_ACCENT_ARR[2],
                                      fontWeight: 600,
                                      fontSize: "0.65rem",
                                      display: "block",
                                      mb: 0.15,
                                    }}
                                  >
                                    Dokumen
                                  </MDTypography>
                                  <MDBox sx={{ mt: 0.5 }}>
                                    {renderDokumenIcon(item.dokumen)}
                                  </MDBox>
                                </MDBox>
                                <MDBox
                                  sx={instruksiListInfoAccentSx(
                                    INSTRUKSI_LIST_ACCENT_ARR[3]
                                  )}
                                  mb={1}
                                >
                                  <MDTypography
                                    variant="caption"
                                    sx={{
                                      color: INSTRUKSI_LIST_ACCENT_ARR[3],
                                      fontWeight: 600,
                                      fontSize: "0.65rem",
                                      display: "block",
                                      mb: 0.15,
                                    }}
                                  >
                                    Respon
                                  </MDTypography>
                                  <MDBox
                                    sx={{ mt: 0.5, maxHeight: 140, overflow: "auto" }}
                                  >
                                    {renderRespon(
                                      item,
                                      item.rincian_penerima,
                                      userId
                                    )}
                                  </MDBox>
                                </MDBox>
                                <MDBox mb={1}>
                                  <MDTypography
                                    variant="caption"
                                    sx={{
                                      color: "text.secondary",
                                      fontWeight: 600,
                                      fontSize: "0.65rem",
                                      display: "block",
                                      mb: 0.5,
                                    }}
                                  >
                                    Penerima lanjutan
                                  </MDTypography>
                                  <MDBox sx={{ maxHeight: 160, overflow: "auto" }}>
                                    {renderPenerimaLanjutan(
                                      item.rincian_penerima,
                                      item
                                    )}
                                  </MDBox>
                                </MDBox>
                                <MDBox
                                  display="flex"
                                  justifyContent="flex-end"
                                  alignItems="center"
                                  gap={0.5}
                                  flexWrap="wrap"
                                  pt={1.5}
                                  mt="auto"
                                  sx={{ borderTop: 1, borderColor: "divider" }}
                                >
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() =>
                                      navigate(
                                        `/task-management/tugas/instruksi-detail/${item.instruksi_id}`,
                                        { state: { instruksi: item } }
                                      )
                                    }
                                    title="Lihat Detail"
                                  >
                                    <VisibilityIcon fontSize="small" />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    disabled={selesai}
                                    onClick={() => handleOpenEditDialog(item)}
                                    title="Edit Instruksi"
                                    sx={{ opacity: selesai ? 0.5 : 1 }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    color="error"
                                    disabled={selesai}
                                    onClick={() => handleOpenDeleteConfirm(item)}
                                    title="Hapus Instruksi"
                                    sx={{ opacity: selesai ? 0.5 : 1 }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </MDBox>
                              </Card>
                            </Grid>
                          );
                        })}
                      </Grid>

                    </>
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      {/* Modal Form Lanjutkan/Selesaikan */}

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          {modalType === "lanjutkan"
            ? "Lanjutkan Instruksi ke Level Bawah"
            : "Selesaikan Instruksi"}
        </DialogTitle>
        <DialogContent sx={{ px: isMobile ? 2 : 3 }}>
          <TextField
            label={
              modalType === "lanjutkan"
                ? "Catatan/Instruksi"
                : "Catatan Penyelesaian/Laporan"
            }
            fullWidth
            multiline
            minRows={3}
            sx={{ mt: 2 }}
            value={modalValues.catatan}
            onChange={(e) => handleModalInput("catatan", e.target.value)}
          />
          <MDBox mt={1}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <MDBox my={2} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    Tags
                  </MDTypography>
                </MDBox>
                {/* Autocomplete hanya tampil jika modalType !== 'selesaikan' */}
                {modalType !== "selesaikan" && (
                  <Autocomplete
                    multiple
                    options={allOptions}
                    value={penerima.penerima || []}
                    onChange={handleChange}
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        {option.value === "all" ? (
                          <strong style={{ color: "#1976d2" }}>
                            Pilih Semua
                          </strong>
                        ) : (
                          <>
                            <MDAvatar
                              src={option.avatar}
                              alt={option.label}
                              size="xs"
                              sx={{ mr: 1 }}
                            />
                            {option.label}
                          </>
                        )}
                      </li>
                    )}
                    renderTags={(selected, getTagProps) =>
                      selected.map((option, index) => (
                        <Chip
                          {...getTagProps({ index })}
                          key={option.value}
                          avatar={
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <MDAvatar
                                src={option.avatar}
                                alt={option.label}
                                size="xxs"
                                sx={{ width: 24, height: 24, mr: 1 }}
                              />
                              <span style={{ marginLeft: 4 }} />
                            </span>
                          }
                          label={option.label}
                          style={{
                            marginRight: 4,
                            marginBottom: 2,
                            display: "flex",
                            alignItems: "center",
                          }}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <MDInput
                        {...params}
                        variant="standard"
                        label="Penerima Instruksi"
                      />
                    )}
                  />
                )}
              </Grid>
            </Grid>
          </MDBox>

          <MDBox mt={2} mb={1}>
            <MDBox mb={2} display="inline-block">
              <MDTypography
                component="label"
                variant="button"
                fontWeight="regular"
                color="text"
                textTransform="capitalize"
              >
                Status Pelaksana
              </MDTypography>
            </MDBox>
            <Autocomplete
              value={modalValues.status_pelaksana || ""}
              onChange={(e, value) =>
                handleModalInput("status_pelaksana", value)
              }
              options={["belum", "proses", "selesai"]}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : String(option)
              }
              renderInput={(params) => (
                <MDInput
                  {...params}
                  variant="standard"
                  label="Pilih Status Pelaksana"
                />
              )}
            />
          </MDBox>

          {/* Input status, waktu instruksi, waktu selesai hanya tampil jika bukan selesaikan */}
          {modalType !== "selesaikan" && (
            <TextField
              label="Waktu Instruksi"
              type="datetime-local"
              fullWidth
              sx={{ mt: 2 }}
              value={modalValues.waktu_diterima}
              onChange={(e) =>
                handleModalInput("waktu_diterima", e.target.value)
              }
              InputLabelProps={{ shrink: true }}
            />
          )}
          <TextField
            label="Waktu Selesai"
            type="datetime-local"
            fullWidth
            sx={{ mt: 2 }}
            value={modalValues.waktu_selesai}
            onChange={(e) => handleModalInput("waktu_selesai", e.target.value)}
            InputLabelProps={{ shrink: true }}
          />

          <MDBox mt={2}>
            <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <MDTypography
                component="label"
                variant="button"
                fontWeight="regular"
                color="text"
              >
                Upload dokumen, jika ada (bisa lebih dari satu file)
                <br />
                <MDTypography
                  component="span"
                  variant="caption"
                  color="text.secondary"
                >
                  Format: PDF, Word, Excel, JPG | Maksimal total: 3 MB untuk
                  semua file
                </MDTypography>
              </MDTypography>
            </MDBox>
            {useMemo(
              () => (
                <MDDropzone
                  options={{
                    addRemoveLinks: true,
                    uploadMultiple: true,
                    maxTotalFilesize: 3, // Maksimal 3 MB total untuk semua file
                    acceptedFiles:
                      ".pdf,.doc,.docx,.xls,.xlsx,.xlsm,.jpg,.jpeg", // PDF, Word, Excel, JPG
                    dictDefaultMessage:
                      "Klik atau seret file ke sini untuk mengunggah",
                    dictTotalFilesTooBig:
                      "Total ukuran semua file melebihi batas maksimal 3 MB",
                    dictInvalidFileType:
                      "Format file tidak didukung. Hanya PDF, Word (DOC/DOCX), Excel (XLS/XLSX), dan JPG yang diperbolehkan",
                    dictResponseError: "Terjadi kesalahan saat mengunggah file",
                    dictCancelUpload: "Batalkan unggah",
                    dictUploadCanceled: "Unggah dibatalkan",
                    dictCancelUploadConfirmation:
                      "Apakah Anda yakin ingin membatalkan unggah?",
                    dictRemoveFile: "Hapus file",
                  }}
                  onChange={handleDropzoneChange}
                  ref={dropzoneRef}
                />
              ),
              []
            )}
            <MDBox mt={1}>
              <MDTypography variant="caption" color="text.secondary">
                * Format yang didukung: PDF, Word (DOC/DOCX), Excel (XLS/XLSX),
                JPG
                <br />* Maksimal total ukuran semua file: 3 MB
              </MDTypography>
            </MDBox>
          </MDBox>
          {/* Preview file yang sudah diupload (jika ingin manual): */}
          {modalValues.files &&
            modalValues.files.length > 0 &&
            (() => {
              // Hitung total ukuran
              const totalSize = modalValues.files.reduce((sum, file) => {
                const fileObj = file.file || file;
                return sum + (fileObj.size || 0);
              }, 0);
              const totalSizeMB = totalSize / (1024 * 1024);
              const maxSizeMB = 3;
              const isExceeding = totalSizeMB > maxSizeMB;

              return (
                <MDBox mt={2}>
                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <MDTypography
                      variant="button"
                      fontWeight="bold"
                      color="text"
                    >
                      File terupload:
                    </MDTypography>
                    <MDTypography
                      variant="caption"
                      color={isExceeding ? "error" : "text.secondary"}
                      fontWeight="medium"
                    >
                      Total: {totalSizeMB.toFixed(2)} MB / {maxSizeMB} MB
                    </MDTypography>
                  </MDBox>
                  <ul style={{ paddingLeft: 16 }}>
                    {modalValues.files.map((file, idx) => {
                      const fileObj = file.file || file;
                      return (
                        <li key={idx} style={{ fontSize: 13 }}>
                          {fileObj.name || "Unknown"} (
                          {fileObj.size
                            ? `${(fileObj.size / 1024).toFixed(2)} KB`
                            : "-"}
                          )
                        </li>
                      );
                    })}
                  </ul>
                </MDBox>
              );
            })()}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseModal}
            color="secondary"
            disabled={loadingModal}
          >
            Batal
          </Button>
          <Button
            onClick={handleSubmitModal}
            color="primary"
            variant="contained"
            disabled={loadingModal}
          >
            {loadingModal ? "Mengirim..." : "Kirim"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Konfirmasi Delete */}
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        fullScreen={isMobile}
      >
        <DialogTitle>Konfirmasi Hapus</DialogTitle>
        <DialogContent sx={{ px: isMobile ? 2 : 3 }}>
          <MDTypography>
            Apakah Anda yakin ingin menghapus instruksi yang
            <b>
              {deleteTarget && deleteTarget.beri_instruksi
                ? " diberikan "
                : " diteruskan "}
            </b>
            ke
            <b> {deleteTarget?.nama_penerima || "-"} </b>?
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)} color="secondary">
            Batal
          </Button>
          <Button onClick={handleDeleteChild} color="error" variant="contained">
            Hapus
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Konfirmasi Delete Instruksi Utama */}
      <Dialog
        open={openDeleteInstruksiDialog}
        onClose={() => setOpenDeleteInstruksiDialog(false)}
        fullScreen={isMobile}
      >
        <DialogTitle>Konfirmasi Hapus Instruksi</DialogTitle>
        <DialogContent sx={{ px: isMobile ? 2 : 3 }}>
          <MDTypography>
            Apakah Anda yakin ingin menghapus instruksi utama ini beserta
            seluruh penerimanya?
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenDeleteInstruksiDialog(false)}
            color="secondary"
          >
            Batal
          </Button>
          <Button
            onClick={handleDeleteInstruksi}
            color="error"
            variant="contained"
          >
            Hapus
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Download File */}
      <Dialog
        open={openFileDialog}
        onClose={() => setOpenFileDialog(false)}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <MDBox display="flex" alignItems="center" gap={1}>
            <Icon sx={{ color: "#1976d2" }}>download</Icon>
            <MDTypography variant="h6" fontWeight="bold" color="dark">
              Download File
            </MDTypography>
          </MDBox>
        </DialogTitle>
        <DialogContent sx={{ px: isMobile ? 2 : 3 }}>
          {selectedFile && (
            <MDBox>
              <MDBox
                display="flex"
                alignItems="center"
                gap={2}
                p={2}
                sx={{
                  background: "#f8f9fa",
                  borderRadius: 1,
                  border: "1px solid #e9ecef",
                  mb: 2,
                }}
              >
                {getFileIcon(selectedFile.name)}
                <MDBox>
                  <MDTypography
                    variant="button"
                    fontWeight="600"
                    color="dark"
                    sx={{ fontSize: "0.875rem" }}
                  >
                    {selectedFile.name}
                  </MDTypography>
                  <MDTypography
                    variant="caption"
                    color="text"
                    sx={{ fontSize: "0.75rem" }}
                  >
                    File type: {selectedFile.type.toUpperCase()}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDTypography
                variant="body2"
                color="text"
                sx={{ lineHeight: 1.5 }}
              >
                File ini akan diunduh ke perangkat Anda. Apakah Anda yakin ingin
                melanjutkan?
              </MDTypography>
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFileDialog(false)} color="secondary">
            Batal
          </Button>
          <Button
            onClick={handleDownloadFile}
            color="primary"
            variant="contained"
            startIcon={<Icon>download</Icon>}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog untuk menampilkan daftar penerima dengan Card */}
      <Dialog
        open={openPenerimaDialog}
        onClose={handleClosePenerimaDialog}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <MDTypography variant="h6" fontWeight="bold" color="dark">
            {penerimaFilterType === "langsung"
              ? "Daftar Penerima Langsung"
              : penerimaFilterType === "lanjutan"
              ? "Daftar Penerima Lanjutan"
              : "Daftar Penerima Instruksi"}
          </MDTypography>
        </DialogTitle>
        <DialogContent>
          <MDBox pt={2} pb={3} px={isMobile ? 2 : 3}>
            {selectedPenerima && selectedPenerima.length > 0 && (
              <>
                {/* Penerima Langsung - hanya tampil jika filterType null atau 'langsung' */}
                {(penerimaFilterType === null ||
                  penerimaFilterType === "langsung") &&
                  selectedPenerima.filter(
                    (p) => p.asal_perintah_dari_id === userId
                  ).length > 0 && (
                    <MDBox mb={penerimaFilterType === null ? 3 : 0}>
                      {penerimaFilterType === null && (
                        <MDTypography
                          variant="h6"
                          fontWeight="bold"
                          color="primary"
                          mb={2}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <Icon>person</Icon>
                          Penerima Langsung (
                          {
                            selectedPenerima.filter(
                              (p) => p.asal_perintah_dari_id === userId
                            ).length
                          }
                          )
                        </MDTypography>
                      )}
                      <Grid container spacing={2}>
                        {selectedPenerima
                          .filter((p) => p.asal_perintah_dari_id === userId)
                          .map((penerima, idx) => {
                            return (
                              <Grid
                                item
                                xs={12}
                                key={
                                  penerima.user_id ||
                                  penerima.penerima_id ||
                                  `penerima-langsung-${idx}`
                                }
                              >
                                {renderPenerimaCard(
                                  penerima,
                                  selectedInstruksiForDialog
                                )}
                              </Grid>
                            );
                          })}
                      </Grid>
                    </MDBox>
                  )}

                {/* Penerima Lanjutan - hanya tampil jika filterType null atau 'lanjutan' */}
                {(penerimaFilterType === null ||
                  penerimaFilterType === "lanjutan") &&
                  selectedPenerima.filter(
                    (p) => p.asal_perintah_dari_id !== userId
                  ).length > 0 && (
                    <MDBox>
                      {penerimaFilterType === null && (
                        <MDTypography
                          variant="h6"
                          fontWeight="bold"
                          color="secondary"
                          mb={2}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <Icon>people</Icon>
                          Penerima Lanjutan (
                          {
                            selectedPenerima.filter(
                              (p) => p.asal_perintah_dari_id !== userId
                            ).length
                          }
                          )
                        </MDTypography>
                      )}
                      <Grid container spacing={2}>
                        {selectedPenerima
                          .filter((p) => p.asal_perintah_dari_id !== userId)
                          .map((penerima, idx) => {
                            return (
                              <Grid
                                item
                                xs={12}
                                key={
                                  penerima.user_id ||
                                  penerima.penerima_id ||
                                  `penerima-lanjutan-${idx}`
                                }
                              >
                                {renderPenerimaCard(
                                  penerima,
                                  selectedInstruksiForDialog
                                )}
                              </Grid>
                            );
                          })}
                      </Grid>
                    </MDBox>
                  )}
              </>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClosePenerimaDialog}
            variant="contained"
            color="primary"
          >
            Tutup
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog untuk menampilkan Isi Instruksi Lengkap */}
      <Dialog
        open={openIsiInstruksiDialog}
        onClose={handleCloseIsiInstruksiDialog}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <MDTypography variant="h6" fontWeight="bold" color="dark">
            Isi Instruksi Lengkap
          </MDTypography>
        </DialogTitle>
        <DialogContent>
          <MDBox pt={2} pb={3} px={isMobile ? 2 : 3}>
            {selectedIsiInstruksi ? (
              <MDBox
                sx={{
                  background: "#fafbfc",
                  p: 2,
                  borderRadius: 1.5,
                  border: "1px solid #e8e8e8",
                }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: selectedIsiInstruksi,
                  }}
                  style={{
                    fontSize: "0.875rem",
                    color: "#333",
                    wordBreak: "break-word",
                    lineHeight: 1.6,
                  }}
                />
              </MDBox>
            ) : (
              <MDTypography variant="body2" color="text.secondary">
                Tidak ada isi instruksi
              </MDTypography>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseIsiInstruksiDialog}
            variant="contained"
            color="primary"
          >
            Tutup
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog untuk menampilkan Perihal Lengkap */}
      <Dialog
        open={openPerihalDialog}
        onClose={handleClosePerihalDialog}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <MDTypography variant="h6" fontWeight="bold" color="dark">
            Perihal Instruksi
          </MDTypography>
        </DialogTitle>
        <DialogContent>
          <MDBox pt={2} pb={3} px={isMobile ? 2 : 3}>
            {selectedPerihal ? (
              <MDBox
                sx={{
                  background: "#fafbfc",
                  p: 2,
                  borderRadius: 1.5,
                  border: "1px solid #e8e8e8",
                }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: selectedPerihal,
                  }}
                  style={{
                    fontSize: "0.875rem",
                    color: "#333",
                    wordBreak: "break-word",
                    lineHeight: 1.6,
                  }}
                />
              </MDBox>
            ) : (
              <MDTypography variant="body2" color="text.secondary">
                Tidak ada perihal
              </MDTypography>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClosePerihalDialog}
            variant="contained"
            color="primary"
          >
            Tutup
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Edit Instruksi */}
      <Dialog
        open={openEditDialog}
        onClose={handleCloseEditDialog}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <MDTypography variant="h6" fontWeight="bold" color="dark">
            Edit Instruksi
          </MDTypography>
        </DialogTitle>
        <DialogContent sx={{ px: isMobile ? 2 : 3 }}>
          <MDBox pt={2} pb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <MDInput
                  label="Perihal"
                  fullWidth
                  value={editFormData.perihal}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      perihal: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  label="Tanggal"
                  type="datetime-local"
                  fullWidth
                  value={editFormData.tanggal}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      tanggal: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDInput
                  label="Tanggal Selesai"
                  type="datetime-local"
                  fullWidth
                  value={editFormData.tanggal_selesai}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      tanggal_selesai: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <MDBox mb={1}>
                  <MDTypography variant="button" fontWeight="medium">
                    Isi Instruksi
                  </MDTypography>
                </MDBox>
                <TextField
                  fullWidth
                  multiline
                  rows={6}
                  value={editFormData.isi_instruksi}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      isi_instruksi: e.target.value,
                    })
                  }
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={["Rendah", "Sedang", "Tinggi"]}
                  value={editFormData.prioritas}
                  onChange={(event, newValue) =>
                    setEditFormData({ ...editFormData, prioritas: newValue })
                  }
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : String(option)
                  }
                  renderInput={(params) => (
                    <MDInput {...params} label="Prioritas" variant="standard" />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <MDBox mb={1}>
                  <MDTypography variant="button" fontWeight="medium">
                    Penerima
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  multiple
                  options={penerimaOptions}
                  value={editFormData.penerima
                    .map((p) =>
                      penerimaOptions.find((opt) => opt.value === p.penerima_id)
                    )
                    .filter(Boolean)}
                  onChange={(event, newValue) => {
                    setEditFormData({
                      ...editFormData,
                      penerima: newValue.map((v) => ({
                        penerima_id: v.value,
                        asal_perintah_dari_id: userId,
                        tingkat_perintah: "1",
                      })),
                    });
                  }}
                  getOptionLabel={(option) => option.label}
                  renderOption={(props, option) => (
                    <MDBox
                      component="li"
                      {...props}
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      {option.avatar && (
                        <MDAvatar src={option.avatar} size="xs" />
                      )}
                      {option.label}
                    </MDBox>
                  )}
                  renderInput={(params) => (
                    <MDInput {...params} variant="standard" />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <MDBox mb={1}>
                  <MDTypography variant="button" fontWeight="medium">
                    Dokumen
                  </MDTypography>
                </MDBox>
                {/* Tampilkan dokumen lama jika ada */}
                {editFormData.dokumen && editFormData.dokumen.length > 0 && (
                  <MDBox mb={2}>
                    <MDTypography
                      variant="caption"
                      color="text.secondary"
                      mb={1}
                    >
                      Dokumen yang sudah ada:
                    </MDTypography>
                    {editFormData.dokumen
                      .filter((d) => typeof d === "string")
                      .map((doc, idx) => (
                        <MDBox
                          key={idx}
                          display="flex"
                          alignItems="center"
                          gap={1}
                          mb={1}
                        >
                          <Icon>insert_drive_file</Icon>
                          <MDTypography variant="caption" color="text">
                            {doc.split("/").pop()}
                          </MDTypography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setEditFormData({
                                ...editFormData,
                                dokumen: editFormData.dokumen.filter(
                                  (d) => d !== doc
                                ),
                              });
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </MDBox>
                      ))}
                  </MDBox>
                )}
                <MDDropzone
                  options={{
                    addRemoveLinks: true,
                  }}
                  onChange={(files) => {
                    // Filter hanya file baru (File object)
                    const newFiles = files.filter((f) => f instanceof File);
                    setEditFormData({
                      ...editFormData,
                      dokumen: [
                        ...editFormData.dokumen.filter(
                          (d) => typeof d === "string"
                        ),
                        ...newFiles,
                      ],
                    });
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog} variant="outlined">
            Batal
          </Button>
          <Button
            onClick={handleSubmitEdit}
            variant="contained"
            color="primary"
            disabled={loadingModal}
          >
            {loadingModal ? "Menyimpan..." : "Simpan"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Konfirmasi Delete */}
      <Dialog
        open={openDeleteConfirmDialog}
        onClose={handleCloseDeleteConfirm}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <MDTypography variant="h6" fontWeight="bold" color="error">
            Konfirmasi Hapus Instruksi
          </MDTypography>
        </DialogTitle>
        <DialogContent sx={{ px: isMobile ? 2 : 3 }}>
          <MDBox pt={2} pb={3}>
            <MDTypography variant="body1" color="text">
              Apakah Anda yakin ingin menghapus instruksi ini? Tindakan ini
              tidak dapat dibatalkan.
            </MDTypography>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDeleteConfirm}
            variant="outlined"
            color="inherit"
          >
            Batal
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            color="error"
            disabled={loadingModal}
          >
            {loadingModal ? "Menghapus..." : "Hapus"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Chat - Material Dashboard Style */}
      <Dialog
        open={openChatDialog}
        onClose={handleCloseChat}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            height: "85vh",
            maxHeight: "85vh",
            display: "flex",
            flexDirection: "column",
            borderRadius: 2,
            overflow: "hidden",
          },
        }}
      >
        {/* Header - Material Dashboard Style */}
        <MDBox
          sx={{
            bgcolor: "info.main",
            color: "white",
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: 2,
          }}
        >
          <MDBox display="flex" alignItems="center" gap={1.5}>
            <MDAvatar
              src={
                selectedChatPenerima?.uid_RSS
                  ? `https://smartdh.rotendaokab.go.id/uploads/${selectedChatPenerima.uid_RSS}.jpg`
                  : undefined
              }
              alt={selectedChatPenerima?.nama}
              size="sm"
              sx={{ border: "2px solid rgba(255,255,255,0.3)" }}
            />
            <MDBox>
              <MDTypography variant="h6" fontWeight="bold" color="white">
                {selectedChatPenerima?.nama || "-"}
              </MDTypography>
              <MDTypography variant="caption" color="white">
                {selectedChatInstruksi?.perihal || "Instruksi"}
              </MDTypography>
            </MDBox>
          </MDBox>
          <MDBox display="flex" gap={1}>
            <IconButton
              onClick={handleRefreshChat}
              disabled={refreshingChat || loadingChat}
              size="small"
              sx={{
                bgcolor: "white",
                color: refreshingChat ? "grey.500" : "grey.700",
                "&:hover": {
                  bgcolor: "grey.100",
                },
                "&:disabled": {
                  bgcolor: "grey.300",
                  color: "grey.500",
                },
              }}
              title="Refresh Chat"
            >
              {refreshingChat ? (
                <CircularProgress size={20} sx={{ color: "grey.500" }} />
              ) : (
                <RefreshIcon />
              )}
            </IconButton>
            <IconButton
              onClick={handleCloseChat}
              size="small"
              sx={{
                bgcolor: "white",
                color: "grey.700",
                "&:hover": {
                  bgcolor: "grey.100",
                },
              }}
            >
              <CancelIcon />
            </IconButton>
          </MDBox>
        </MDBox>

        {/* Chat Messages Area - Material Dashboard Style */}
        <MDBox
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            position: "relative",
            bgcolor: "grey.100",
          }}
        >
          {loadingChat ? (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              flex={1}
            >
              <CircularProgress />
            </MDBox>
          ) : (
            <MDBox
              sx={{
                flex: 1,
                overflowY: "auto",
                p: 2,
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(0,0,0,0.2)",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "rgba(0,0,0,0.3)",
                },
              }}
            >
              {chatMessages.length === 0 ? (
                <MDBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flex={1}
                >
                  <MDTypography variant="body2" color="text.secondary">
                    Belum ada pesan. Mulai percakapan!
                  </MDTypography>
                </MDBox>
              ) : (
                chatMessages.map((message, idx) => {
                  const currentUser =
                    JSON.parse(localStorage.getItem("user")) || {};
                  const currentUserId =
                    userId || currentUser.uid || currentUser.user_id;
                  const isOwnMessage = message.pengirim_id === currentUserId;
                  const isSending = message.isSending;

                  return (
                    <MDBox
                      key={message.id_chat || idx}
                      display="flex"
                      justifyContent={isOwnMessage ? "flex-end" : "flex-start"}
                      sx={{ mb: 0.5, px: 0.5 }}
                    >
                      <MDBox
                        sx={{
                          maxWidth: "75%",
                          minWidth: "100px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: isOwnMessage ? "flex-end" : "flex-start",
                        }}
                      >
                        {/* Avatar dan nama untuk pesan lawan */}
                        {!isOwnMessage && (
                          <MDBox
                            display="flex"
                            alignItems="center"
                            gap={0.5}
                            mb={0.3}
                            sx={{ px: 0.5 }}
                          >
                            <MDAvatar
                              src={
                                message.pengirim_profil
                                  ? `https://smartdh.rotendaokab.go.id/uploads/${message.pengirim_profil}.jpg`
                                  : undefined
                              }
                              size="xs"
                            />
                            <MDTypography
                              variant="caption"
                              color="text.secondary"
                              sx={{ fontSize: "0.7rem", fontWeight: 500 }}
                            >
                              {message.pengirim_nama || "-"}
                            </MDTypography>
                          </MDBox>
                        )}

                        {/* Bubble Chat */}
                        <MDBox
                          sx={{
                            p: 1.25,
                            px: 1.5,
                            borderRadius: isOwnMessage
                              ? "7.5px 0 7.5px 7.5px"
                              : "0 7.5px 7.5px 7.5px",
                            backgroundColor: isOwnMessage ? "#4caf50" : "white",
                            color: isOwnMessage ? "white" : "text.primary",
                            wordBreak: "break-word",
                            boxShadow: 1,
                            position: "relative",
                            opacity: isSending ? 0.7 : 1,
                            border: isOwnMessage ? "none" : "1px solid",
                            borderColor: "divider",
                          }}
                        >
                          <MDTypography
                            variant="body2"
                            sx={{
                              color: isOwnMessage ? "white" : "text.primary",
                              fontSize: "0.95rem",
                              lineHeight: 1.4,
                              whiteSpace: "pre-wrap",
                            }}
                          >
                            {message.pesan}
                            {isSending && (
                              <MDBox
                                component="span"
                                sx={{
                                  display: "inline-block",
                                  ml: 0.5,
                                  verticalAlign: "middle",
                                }}
                              >
                                <CircularProgress
                                  size={12}
                                  sx={{ color: "white" }}
                                />
                              </MDBox>
                            )}
                          </MDTypography>
                        </MDBox>

                        {/* Timestamp dan Read Status */}
                        <MDBox
                          display="flex"
                          alignItems="center"
                          gap={0.5}
                          sx={{ mt: 0.2, px: 0.5 }}
                        >
                          <MDTypography
                            variant="caption"
                            sx={{
                              fontSize: "0.65rem",
                              color: "#4caf50",
                              fontWeight: 400,
                            }}
                          >
                            {formatChatTime(message.waktu_kirim)}
                          </MDTypography>
                          {isOwnMessage && !isSending && (
                            <MDBox
                              sx={{
                                width: "12px",
                                height: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CheckCircleIcon
                                sx={{
                                  fontSize: "12px",
                                  color: message.waktu_baca
                                    ? "#4caf50"
                                    : "rgba(255,255,255,0.6)",
                                }}
                              />
                            </MDBox>
                          )}
                          {isOwnMessage && message.waktu_baca && (
                            <MDTypography
                              variant="caption"
                              sx={{
                                fontSize: "0.6rem",
                                color: "rgba(11, 183, 25, 0.7)",
                                fontStyle: "italic",
                              }}
                            >
                              Dibaca {formatChatTime(message.waktu_baca)}
                            </MDTypography>
                          )}
                          {/* Tombol Delete */}
                          {isOwnMessage && !isSending && (
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleDeleteMessage(message.id_chat)
                              }
                              sx={{
                                width: "20px",
                                height: "20px",
                                color: "rgba(255,255,255,0.7)",
                                "&:hover": {
                                  color: "white",
                                  backgroundColor: "rgba(255,255,255,0.1)",
                                },
                              }}
                            >
                              <DeleteIcon sx={{ fontSize: "14px" }} />
                            </IconButton>
                          )}
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  );
                })
              )}
              <div ref={chatEndRef} />
            </MDBox>
          )}
        </MDBox>

        {/* Input Area - Material Dashboard Style */}
        <MDBox
          sx={{
            bgcolor: "grey.50",
            p: 1.5,
            borderTop: "1px solid",
            borderColor: "divider",
            display: "flex",
            alignItems: "flex-end",
            gap: 1,
          }}
        >
          <TextField
            fullWidth
            placeholder="Ketik pesan..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                handleSendMessage();
              }
            }}
            multiline
            maxRows={4}
            size="small"
            disabled={loadingChat}
            sx={{
              bgcolor: "white",
              borderRadius: "20px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "20px",
                "& fieldset": {
                  borderColor: "rgba(0,0,0,0.1)",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(0,0,0,0.2)",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#000000",
                },
              },
            }}
          />
          <IconButton
            onClick={handleSendMessage}
            disabled={!newMessage.trim() || loadingChat}
            sx={{
              bgcolor: "#000000",
              color: "white",
              width: "40px",
              height: "40px",
              "&:hover": {
                bgcolor: "#333333",
              },
              "&:disabled": {
                bgcolor: "rgba(0,0,0,0.1)",
                color: "rgba(0,0,0,0.3)",
              },
            }}
          >
            <SendIcon fontSize="small" />
          </IconButton>
        </MDBox>
      </Dialog>

      {/* Dialog Respon Pemberi Instruksi */}
      <Dialog
        open={openResponDialog}
        onClose={handleCloseResponDialog}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <MDTypography variant="h6" fontWeight="bold" color="dark">
            {selectedPenerimaForRespon?.respon_pemberi_instruksi
              ? "Edit Respon"
              : "Berikan Respon"}
          </MDTypography>
        </DialogTitle>
        <DialogContent sx={{ px: isMobile ? 2 : 3 }}>
          {selectedPenerimaForRespon && (
            <MDBox py={2}>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                mb={3}
              >
                <Avatar
                  src={
                    selectedPenerimaForRespon.uid_RSS ||
                    selectedPenerimaForRespon.instruksi?.penerima?.uid_RSS
                      ? `https://smartdh.rotendaokab.go.id/uploads/${
                          selectedPenerimaForRespon.uid_RSS ||
                          selectedPenerimaForRespon.instruksi?.penerima?.uid_RSS
                        }.jpg`
                      : undefined
                  }
                  alt={selectedPenerimaForRespon.nama}
                  sx={{
                    width: "100px",
                    height: "100px",
                    border: "3px solid",
                    borderColor: "primary.main",
                    mb: 2,
                    boxShadow: 3,
                    fontSize: "2.5rem",
                    bgcolor: "info",
                  }}
                >
                  {selectedPenerimaForRespon.nama
                    ? selectedPenerimaForRespon.nama.charAt(0).toUpperCase()
                    : "👤"}
                </Avatar>
                <MDTypography variant="h6" color="text" fontWeight="medium">
                  {selectedPenerimaForRespon.nama || "Penerima"}
                </MDTypography>
                <MDTypography variant="body2" color="text.secondary">
                  Penerima Instruksi
                </MDTypography>
              </MDBox>

              <MDTypography
                variant="body2"
                color="text"
                mb={2}
                textAlign="center"
              >
                Pilih respon Anda terhadap penyelesaian instruksi ini:
              </MDTypography>

              <MDBox display="flex" flexDirection="column" gap={1.5}>
                <MDButton
                  variant={
                    selectedRespon === "Terima" ? "gradient" : "outlined"
                  }
                  color={selectedRespon === "Terima" ? "success" : "success"}
                  onClick={() => handleSelectRespon("Terima")}
                  startIcon={<Icon>check_circle</Icon>}
                  fullWidth
                  sx={{
                    justifyContent: "flex-start",
                    py: 1.5,
                  }}
                >
                  Terima
                </MDButton>
                <MDButton
                  variant={
                    selectedRespon === "Perbaiki" ? "gradient" : "outlined"
                  }
                  color={selectedRespon === "Perbaiki" ? "warning" : "warning"}
                  onClick={() => {
                    setSelectedRespon("Perbaiki");
                  }}
                  startIcon={<Icon>edit</Icon>}
                  fullWidth
                  sx={{
                    justifyContent: "flex-start",
                    py: 1.5,
                  }}
                >
                  Perbaiki
                </MDButton>
                <MDButton
                  variant={selectedRespon === "Tolak" ? "gradient" : "outlined"}
                  color={selectedRespon === "Tolak" ? "error" : "error"}
                  onClick={() => {
                    setSelectedRespon("Tolak");
                  }}
                  startIcon={<Icon>cancel</Icon>}
                  fullWidth
                  sx={{
                    justifyContent: "flex-start",
                    py: 1.5,
                  }}
                >
                  Tolak
                </MDButton>
              </MDBox>
            </MDBox>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <MDButton
            variant="outlined"
            color="secondary"
            onClick={handleCloseResponDialog}
          >
            Batal
          </MDButton>
          {/* Tombol Kirim hanya muncul untuk Tolak dan Perbaiki */}
          {selectedRespon !== "Terima" && (
            <MDButton
              variant="gradient"
              color="success"
              onClick={handleSubmitRespon}
              disabled={!selectedRespon || submittingRespon}
              startIcon={<Icon>send</Icon>}
            >
              {submittingRespon ? "Mengirim..." : "Kirim"}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>

      {/* Dialog Rating Bintang untuk Respon Terima */}
      <Dialog
        open={openRatingDialog}
        onClose={() => {}} // Disable close on backdrop click
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        disableEscapeKeyDown
      >
        <DialogTitle>
          <MDTypography variant="h5" color="text" fontWeight="bold">
            {selectedPenerimaForRespon?.respon_pemberi_instruksi === "Terima" &&
            selectedPenerimaForRespon?.nilai
              ? "Edit Penilaian Instruksi"
              : "Penilaian Instruksi"}
          </MDTypography>
        </DialogTitle>
        <DialogContent sx={{ px: isMobile ? 2 : 3 }}>
          <MDBox textAlign="center" py={2}>
            {/* Tampilkan informasi penerima */}
            {selectedPenerimaForRespon && (
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                mb={3}
              >
                <Avatar
                  src={
                    selectedPenerimaForRespon.uid_RSS ||
                    selectedPenerimaForRespon.instruksi?.penerima?.uid_RSS
                      ? `https://smartdh.rotendaokab.go.id/uploads/${
                          selectedPenerimaForRespon.uid_RSS ||
                          selectedPenerimaForRespon.instruksi?.penerima?.uid_RSS
                        }.jpg`
                      : undefined
                  }
                  alt={selectedPenerimaForRespon.nama}
                  sx={{
                    width: "100px",
                    height: "100px",
                    border: "3px solid",
                    borderColor: "primary.main",
                    mb: 2,
                    boxShadow: 3,
                    fontSize: "2.5rem",
                    bgcolor: "info",
                  }}
                >
                  {selectedPenerimaForRespon.nama
                    ? selectedPenerimaForRespon.nama.charAt(0).toUpperCase()
                    : "👤"}
                </Avatar>
                <MDTypography variant="h6" color="text" fontWeight="medium">
                  {selectedPenerimaForRespon.nama || "Penerima"}
                </MDTypography>
                <MDTypography variant="body2" color="text.secondary">
                  Penerima Instruksi
                </MDTypography>
              </MDBox>
            )}
            <MDTypography variant="body2" color="text" mb={2}>
              Silakan berikan penilaian Anda terhadap penyelesaian instruksi:
            </MDTypography>
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={1}
              flexWrap="wrap"
              sx={{
                py: 3,
              }}
            >
              {[1, 2, 3, 4, 5].map((rating) => (
                <MDBox
                  key={rating}
                  onClick={() => handleRatingClick(rating)}
                  sx={{
                    cursor: "pointer",
                    width: "75px",
                    height: "75px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "&:hover": {
                      transform: "scale(1.1)",
                      transition: "transform 0.2s",
                    },
                    transition: "transform 0.2s",
                    "@media (max-width: 600px)": {
                      width: "50px",
                      height: "50px",
                    },
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="60"
                    height="60"
                    fill={selectedRating >= rating ? "#FFD700" : "#E0E0E0"}
                    style={{
                      transition: "fill 0.2s",
                    }}
                  >
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                </MDBox>
              ))}
            </MDBox>
            {selectedRating > 0 && (
              <MDTypography
                variant="body2"
                color="text.secondary"
                mt={2}
                sx={{ fontStyle: "italic" }}
              >
                Anda memberikan {selectedRating} bintang
                {selectedRating === 1
                  ? " (Sangat Tidak Puas)"
                  : selectedRating === 2
                  ? " (Tidak Puas)"
                  : selectedRating === 3
                  ? " (Cukup)"
                  : selectedRating === 4
                  ? " (Puas)"
                  : " (Sangat Puas)"}
              </MDTypography>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <MDButton
            variant="outlined"
            color="secondary"
            onClick={handleCancelRating}
          >
            Batal
          </MDButton>
          <MDButton
            variant="gradient"
            color="success"
            onClick={handleSubmitRating}
            disabled={selectedRating === 0 || submittingRespon}
            startIcon={<Icon>send</Icon>}
          >
            {submittingRespon ? "Mengirim..." : "Kirim"}
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default DaftarTugas;
